import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";


import {
  IonContent,
  IonPage,
  IonIcon,
  useIonModal,
  useIonToast,
  IonItem,
  IonList,
  isPlatform,
  IonPopover,
  useIonAlert,
} from "@ionic/react";

import { useMapFunctions } from "./hooks";
import { useMapLogic } from "./hooks";

import {
  receiptOutline,
  navigate,
  searchOutline,
  caretDownCircleOutline,
  add,
  newspaperOutline,
} from "ionicons/icons";

import MapView from "@arcgis/core/views/MapView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import Polygon from "@arcgis/core/geometry/Polygon";
import Polyline from "@arcgis/core/geometry/Polyline";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Geometry from "@arcgis/core/geometry/Geometry";
import Request from "@arcgis/core/request";
import Query from "@arcgis/core/rest/support/Query";
import * as route from "@arcgis/core/rest/route";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";

import { Geolocation } from "@capacitor/geolocation";
import { Device } from "@capacitor/device";

import Spinner from "../../components/atoms/spinner";
import ErrorModal from "../../components/molecules/errorModal";
import PropertyTypesModal from "../../components/molecules/propertyTypesModal";
import SccessMessage from "../../components/atoms/tosterMessage";
import ruler from "../../images/ruler.svg";

import {
  useFormState,
  useDataArraysState,
  useUIState,
  useErrorState,
  useUserRoleState,
  useFeatureState,
  useLogoState,
  useLocationState,
  usePropertyDataState,
  useSearchState,
  useIntegrationState
} from "./hooks";

import {
  stopTextSymbol,
  startTextSymbol,
  routeSymbol,
  routeUrl as routingUrl,
  routeParams as importedRouteParams
} from "./utils/routingFunctions";
import {
  InfoModal,
  WhatsAppModal,
  CreateFavoriteLandModal,
  CreateBuildingsWalletModal,
  SignInModal,
  EditModal,
  LandOperationsModal,
  LogoPointsModal,
  FilterModal,
  LegendModal,
  FavoriteLandByParcCodeModal,
  PropertyModal,
  SearchSelectionModal,
  FiltersDropdown
} from "./modals";
import {
  DealTypeId,
  FilterSelection,
  checkedTypes,
  listPropertyTypes,
  reconcileSelection,
} from "./utils/offerFilters";

import { getBaladyAccessToken, getPointDataWithTokenRefresh } from "../../services/API/baladyService";
import { getPolygonCenterPoint, selectedSymbolElshamalya } from "../../services/genericMethoud/gisMethouds";
import { PointLogosDTO } from "../../services/models/pointLogoDTO";

import Profile from "../profile";
import Property from "../property";
import NhcAdvertisement from "../nhcAdvertisement";
import AddPropertyNhcIntegration from "../nhcIntegration";
import EstateBrokersModal from "../estateBrokers/estateBrokersModal";
import TrackingModals from "../tracking/TrackingModals";
import DocsReportModel from "../profile/docsReportModel";
import BuildingsWalletSingleModel from "../BuildingsWallet/BuildingsWalletSingleList";

import Logo from "../../images/logo.png";
import realEstateBrokerSvg from "../../images/realEstateBroker.svg";
import close from "../../images/close.svg";
import FalLogo from "../../images/falLogo.svg";
import menuImage from "../../images/menu.svg";
import LegendImage from "../../images/Legned.png";
import LoginImage from "../../images/login.svg";
import googlePinIcon from "../../images/location.svg";

import {
  CreateBuildingsWalletFunc,
  createFavoriteLandFunction,
  createLogosDataFunction,
  deleteLogosDataFunction,
  getAPPVersionsFunction,
  GetBuildingsWalletFunc,
  getFavoriteLandByParcCodeFunction,
  getLogosDataFunction,
  getNhcIntegrationByAdLicenseNumberFunction,
  getNhcIntegrationByObjIdFunction,
  getAdsForMapFilterFunction,
  GetPointData,
  getRegionDataByCode,
  GetUserFunction,
} from "../../services/API";
import showOnGoogleMapsFunction from "../../services/others/showOnGoogleMaps";
import shareOnWhatsAppFunction from "../../services/others/shareOnWhatsApp";

import {
  arcgisServicesBaseUrl,
  arcgisServicesBaseMinistryUrl,
  arcgisServicesLandFeatureUrl,
} from "../../configs/arcgisServices";
import {
  handleStyleButtonByLandTypes,
  presentToastFunction,
} from "../../services/genericMethoud/generice";
import { AndoridVersion, IOSVersion } from "../../configs/GenericConfig";
import { NumberWithCommas } from "../../configs/GenericFunc";

import { setSignInAsVisitor, setUserInfo } from "../../services/redux/actions";
import { PointDataEnvelope } from "../../services/models/PointDataResponse";
import { OverlayEventDetail } from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import QRCode from "react-qr-code";
import "./index.css";
import { createFeatureGraphics, getRegions } from "./utils";

let isZoomTracking: boolean = false;

// Route URL for navigation
const routeUrl = routingUrl;



//   // Map initialization is now handled by useMapLogic hook
//   let MapViewData: MapView;

// window.F_Land_parcelsFlashLight = new FeatureLayer({});
// window.F_Land_parcels = new FeatureLayer({});
// window.F_FavoriteLand = new FeatureLayer({});

// Route parameters for navigation
const routeParams = importedRouteParams;

const Home: React.FC = () => {
  const mapFunctions = useMapFunctions();
  const mapLogic = useMapLogic();

  const zoomToLayer = (type: any, geometry: any, wiki: any, ZoomLevel: any) => {
    mapLogic.zoomToLayer(type, geometry, wiki, ZoomLevel);
  };

  const { userInfo, authenticationState, token } = useSelector((state: any) => state.reducer);
  const dispatch = useDispatch();
  const history = useHistory();
  const [presentToast] = useIonToast();
  const [presentAlert] = useIonAlert();

  const inputClassWithError = "input-error block px-5 py-2.5 placeholder-paragraphColor w-full text-sm bg-transparent rounded border-2 border-paragraphColor appearance-none focus:outline-none focus:ring-0 focus:border-blue-600";
  const inputClassWithOutError = "block px-5 py-2.5 placeholder-paragraphColor w-full text-sm bg-transparent rounded border-2 border-paragraphColor appearance-none focus:outline-none focus:ring-0 focus:border-blue-600";

  const formState = useFormState();
  const dataArraysState = useDataArraysState();
  const uiState = useUIState();
  const errorState = useErrorState();
  const userRoleState = useUserRoleState();
  const featureState = useFeatureState();
  const logoState = useLogoState();
  const locationState = useLocationState();
  const propertyDataState = usePropertyDataState();
  const searchState = useSearchState();
  const integrationState = useIntegrationState();

  const location = useLocation();

  // Filters dropdown: property type + deal per row, plus requests/wallets layers
  const [isLoadingMapAds, setIsLoadingMapAds] = useState<boolean>(true);
  // Row order for the dropdown, as sent by the API (types ranked by how many ads
  // carry each). Empty until the request lands, and empty for the older response
  // shape, in which case listPropertyTypes falls back to the ads' own order.
  const [apiTypeOrder, setApiTypeOrder] = useState<string[]>([]);
  const propertyTypes = listPropertyTypes(uiState.mapAds, apiTypeOrder);

  React.useEffect(() => {
    let cancelled = false;

    getAdsForMapFilterFunction()
      .then((response: any) => {
        if (cancelled) {
          return;
        }

        // Two shapes are accepted so the API can be deployed before this bundle:
        // the current { propertyTypes, ads } and the older bare array.
        const payload = response?.data;
        const rows = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.ads ?? payload?.Ads)
          ? payload.ads ?? payload.Ads
          : [];
        const order = payload?.propertyTypes ?? payload?.PropertyTypes;

        setApiTypeOrder(
          Array.isArray(order) ? order.map((type: any) => String(type)) : []
        );
        uiState.setMapAds(
          rows.map((row: any) => ({
            objectId: Number(row.objectId ?? row.ObjectId),
            propertyType: String(row.propertyType ?? row.PropertyType ?? ""),
          }))
        );
      })
      .catch((error: any) => {
        // Leaving mapAds empty keeps the layers on their base expression, so a
        // failed request shows every offer rather than hiding them all.
        console.error("Error loading ads for map filter:", error);
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoadingMapAds(false);
        }
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const offerSelection: FilterSelection = React.useMemo(
    () => reconcileSelection(uiState.mapAds, uiState.offerFilterSelection),
    [uiState.mapAds, uiState.offerFilterSelection]
  );

  const commitOfferSelection = (next: FilterSelection) => {
    uiState.setOfferFilterSelection(next);
    mapLogic.applyOfferFilters(uiState.mapAds, next);
  };

  // Apply the filter once the ads arrive, since they usually land after the map
  // has finished initialising. With no ads there is nothing to filter by.
  React.useEffect(() => {
    if (uiState.mapAds.length > 0) {
      mapLogic.applyOfferFilters(uiState.mapAds, offerSelection);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uiState.mapAds]);

  const handleToggleType = (propertyType: string) => {
    // Unchecking records null rather than removing the key: a missing key means
    // "type not seen yet" and would be restored as checked on the next render.
    commitOfferSelection({
      ...offerSelection,
      [propertyType]: offerSelection[propertyType] != null ? null : "sale",
    });
  };

  const handlePickDeal = (propertyType: string, deal: DealTypeId) => {
    commitOfferSelection({ ...offerSelection, [propertyType]: deal });
  };

  const activeFilterCount =
    checkedTypes(offerSelection).length +
    (uiState.showFavoriteIcons ? 1 : 0) +
    (uiState.showWalletIcons ? 1 : 0);

  // Measurement state variables
  const [measuringMode, setMeasuringMode] = useState<'distance' | 'area' | null>(null);
  const [isMeasuring, setIsMeasuring] = useState<boolean>(false);
  const [currentMeasurement, setCurrentMeasurement] = useState<number>(0);
  const [measurementPoints, setMeasurementPoints] = useState<Point[]>([]);
  const [measurementClickHandler, setMeasurementClickHandler] = useState<any>(null);

  // Create refs to track measurement state globally
  const measurementModeRef = React.useRef<boolean>(false);
  const measurementPointsRef = React.useRef<Point[]>([]);
  const plotDataClickHandlerRef = React.useRef<any>(null);

  // MapViewData=window.mapviews ;
  mapLogic.map = window.map;

  const setSignInAsVisitorFunction = (returnedData: Object) =>
    dispatch(setSignInAsVisitor(returnedData));

  let [present, dismiss] = useIonModal(Profile, {
    history: history,
    onDismiss: (data: string, role: string) => dismiss(data, role),
  });

  function openProfileModal() {
    present({
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        window.F_Land_parcels.refresh();
        if (ev.detail.role === "confirm") {
          window.F_Land_parcels.refresh();
        }
      },
    });
  }

  let [presentproperty, dismissproperty] = useIonModal(Property, {
    baseLandType: (featureState.property as any)?.attributes?.Parcel_Status,
    propertyNumber: formState.propertyNumber,
    objectId: logoState.objectId,
    parcel_Cod: logoState.parcel_Cod,
    latitude: featureState.property?.geometry ? getPolygonCenterPoint(featureState.property.geometry as any)?.latitude || 0 : 0,
    longitude: featureState.property?.geometry ? getPolygonCenterPoint(featureState.property.geometry as any)?.longitude || 0 : 0,
    district_Name: locationState.district_Name,
    region_Name: locationState.region_Name,
    city_Name: locationState.city_Name,
    sUBDIVISIONPLAN_ID: logoState.sUBDIVISIONPLAN_ID,
    rings: featureState.property?.geometry?.rings,
    dismissproperty: (data: string, role: string) =>
      dismissproperty(data, role),
  });

  let [presentErrorModal, dismissErrorModal] = useIonModal(ErrorModal, {
    errorTitle: errorState.errorTitle,
    errorMessage: errorState.errorMessage,
    dismissErrorModal: (data: string, role: string) =>
      dismissErrorModal(data, role),
  });

  function openpErrorModal() {
    presentErrorModal({
      animated: true,
      breakpoints: [1, 1, 1, 0.5, 1],
      initialBreakpoint: 0.5,
      // backdropBreakpoint: 0.5,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }
  let [presentSccessMessage, dismissSccessMessage] = useIonModal(
    SccessMessage,
    {
      messageTitle: errorState.errorTitle,
      message: errorState.errorMessage,
      dismissSccessMessage: (data: string, role: string) =>
        dismissSccessMessage(data, role),
    }
  );

  let [buildingsWalletSingleItem, setBuildingsWalletSingleItem] =
    useState<any>(null);
  let [buildingWalletSingle, isBuildingWalletSingle] = useState<any>(null);

  const [presentBuildingsWalletSingleModel, dismissBuildingsWalletSingleModel] =
    useIonModal(BuildingsWalletSingleModel, {
      itemsData: buildingsWalletSingleItem,
      dismissBuildingsWalletSingleModel: (data: string, role: string) =>
        dismissBuildingsWalletSingleModel(data, role),
    });

  function openBuildingsWalletSingleModel() {
    presentBuildingsWalletSingleModel({
      animated: true,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
          getBuildingsWalletFuncData();
        }
      },
    });
  }

  let [presentPropertyTypesModal, dismissPropertyTypesModal] = useIonModal(
    PropertyTypesModal,
    {
      baseLandType: (featureState.property as any)?.attributes?.Parcel_Status,
      propertyNumber: formState.propertyNumber,
      objectId: logoState.objectId,
      parcel_Cod: logoState.parcel_Cod,
      latitude: featureState.property?.geometry ? getPolygonCenterPoint(featureState.property.geometry as any)?.latitude || 0 : 0,
      longitude: featureState.property?.geometry ? getPolygonCenterPoint(featureState.property.geometry as any)?.longitude || 0 : 0,
      rings: featureState.property?.geometry?.rings,
      city_Name: locationState.city_Name,
      region_Name: locationState.region_Name,
      district_Name: locationState.district_Name,
      dismissPropertyTypesModal: (data: string, role: string) =>
        dismissPropertyTypesModal(data, role),
    }
  );

  let getPlotData = () => {
    const clickHandler = mapLogic.MapViewData.on("click", (event: any) => {
      // Skip property selection if in measurement mode
      if (measurementModeRef.current) {
        return;
      }

      uiState.setIsLoading(true);

      propertyDataState.setCurrentEventClick(event);

      // Get the click point in map coordinates
      const screenPoint = {
        x: event.x,
        y: event.y
      };

      // Convert screen point to map point
      const mapPoint = mapLogic.MapViewData.toMap(screenPoint);

      // Create a buffer around the click point for better hit detection
      const bufferDistance = 10; // meters - adjust this value based on your needs

      // Create a proper polygon buffer around the map point
      let bufferGeometry: Geometry | Polygon | Polygon[];
      try {
        bufferGeometry = geometryEngine.buffer(mapPoint, bufferDistance, "meters");
      } catch (error) {
        console.warn("Failed to create buffer geometry, using original map point:", error);
        bufferGeometry = mapPoint; // Fallback to original point
      }

      // Query features using the map point
      const queryFeaturesAtPoint = async () => {
        let returnedData: any = null;

        try {
          // Query land parcels layer using buffer geometry
          const landParcelsQuery = {
            geometry: mapPoint,
            spatialRelationship: "intersects",
            outFields: ["*"],
            returnGeometry: true,
            where: "Parcel_Status IS NOT NULL"
          };

          // Query land parcels layer using buffer geometry
          const landParcelsFlashLightQuery = {
            geometry: mapPoint,
            spatialRelationship: "intersects",
            outFields: ["*"],
            returnGeometry: true,
            where: "Feature_Ad ='true'"
          };

          const favoriteLandQuery = {
            geometry: bufferGeometry,
            spatialRelationship: "intersects",
            outFields: ["*"],
            returnGeometry: true,
          };
          console.log("favoriteLandQuery===>", favoriteLandQuery);
          console.log("Buffer geometry created:", bufferGeometry);
          console.log("Buffer distance:", bufferDistance, "meters");
          // Use view.hitTest for graphics layers and queryFeatures for feature layers
          const [hitTestResponse, F_Land_parcels, F_Land_parcelsFlashLight, F_FavoriteLand] = await Promise.all([
            mapLogic.MapViewData.hitTest(event),
            window.F_Land_parcels?.queryFeatures(landParcelsQuery) || Promise.resolve({ features: [] }),
            window.F_Land_parcelsFlashLight?.queryFeatures(landParcelsFlashLightQuery) || Promise.resolve({ features: [] }),
            window.F_FavoriteLand?.queryFeatures(favoriteLandQuery) || Promise.resolve({ features: [] })
          ]);

          // Filter graphics by specific layers
          const graphicsbuildingsWalletLayer = hitTestResponse.results?.filter(
            (hitResult: any) => hitResult.type === "graphic" &&
              (hitResult.graphic.layer === window.graphicsbuildingsWalletLayer ||
                hitResult.graphic.layer?.id === "graphicsbuildingsWalletLayer" ||
                hitResult.graphic.layer?.id === "buildingsWalletLayer")
          ) || [];

          const graphicsLogoLayerlogoAdd = hitTestResponse.results?.filter(
            (hitResult: any) => hitResult.type === "graphic" &&
              hitResult.graphic.layer === window.graphicsLogoLayerlogoAdd
          ) || [];

          const graphicsLogoLayer = hitTestResponse.results?.filter(
            (hitResult: any) => hitResult.type === "graphic" &&
              hitResult.graphic.layer === window.graphicsLogoLayer
          ) || [];

          // Format results to match expected structure
          returnedData = {
            results: [
              // Graphics layers from hitTest
              ...graphicsbuildingsWalletLayer.map((hitResult: any) => ({
                graphic: hitResult.graphic,
                mapPoint: mapPoint
              })),
              ...graphicsLogoLayerlogoAdd.map((hitResult: any) => ({
                graphic: hitResult.graphic,
                mapPoint: mapPoint
              })),
              ...graphicsLogoLayer.map((hitResult: any) => ({
                graphic: hitResult.graphic,
                mapPoint: mapPoint
              })),
              // Feature layers return features array from queryFeatures
              ...F_Land_parcels.features.map((feature: any) => ({
                graphic: feature,
                mapPoint: mapPoint
              })),
              ...F_Land_parcelsFlashLight.features.map((feature: any) => ({
                graphic: feature,
                mapPoint: mapPoint
              })),
              ...F_FavoriteLand.features.map((feature: any) => ({
                graphic: feature,
                mapPoint: mapPoint
              }))
            ],
            mapPoint: mapPoint // Add mapPoint at the top level as well
          };

          console.log("returnedDatass", returnedData);
          //console.log("mapLogic.MapViewData", mapLogic.MapViewData);


          let getGraphicsbuildingsWalletLayer = returnedData.results.filter(
            (layer: any) =>
              layer.graphic.layer?.id == "graphicsbuildingsWalletLayer" ||
              layer.graphic.layer?.id == "buildingsWalletLayer"
          );
          let getF_Land_parcelsLayer;
          let getParcel_CodFromF_Land_parcelsLayer;

          if (returnedData && returnedData.results.length > 0) {
            getF_Land_parcelsLayer = returnedData.results.filter(
              (layer: any) =>
                ["F_Land_parcels", "graphicsLogoLayer"].includes(layer.graphic.layer?.id)
            );
          }
          if (getF_Land_parcelsLayer && getF_Land_parcelsLayer[0]?.graphic?.attributes) {
            getParcel_CodFromF_Land_parcelsLayer =
              getF_Land_parcelsLayer[0].graphic.attributes.Parcel_Cod;
          }

          if (
            getGraphicsbuildingsWalletLayer != null &&
            getGraphicsbuildingsWalletLayer.length > 0
          ) {
            isBuildingWalletSingle(true);
            setBuildingsWalletSingleItem({
              id: getGraphicsbuildingsWalletLayer[0].graphic.attributes
                .buildingsWalletId,
              land_Numbe:
                getGraphicsbuildingsWalletLayer[0].graphic.attributes.land_Numbe,
              parcel_Cod:
                getGraphicsbuildingsWalletLayer[0].graphic.attributes.parcel_Cod,
              title: getGraphicsbuildingsWalletLayer[0].graphic.attributes.title,
            });
            openBuildingsWalletSingleModel();

          } else {
            isBuildingWalletSingle(false);
          }

          // Store coordinates in state for WhatsApp sharing
          console.log("returnedData WhatsApp", returnedData);
          if (returnedData?.mapPoint) {
            locationState.setCurrentLongitude(returnedData.mapPoint.longitude);
            locationState.setCurrentLatitude(returnedData.mapPoint.latitude);
          }


        } catch (error) {
          console.error("Error querying features:", error);
        }

        // Always return mapPoint even if no results found
        if (!returnedData) {
          return {
            results: [],
            mapPoint: mapPoint
          };
        }

        return returnedData;
      };

      // Execute the query function
      queryFeaturesAtPoint().then(async (returnedData: any) => {
        if (returnedData && (returnedData.results.length > 0 || returnedData.mapPoint)) {
          // Get the parcel code from land parcels layer
          //console.log("returnedData", returnedData);
          let getParcel_CodFromF_Land_parcelsLayer: string | undefined;
          let logoId: string | undefined;
          const landParcelsResults = returnedData.results.filter(
            (layer: any) =>
              ["F_Land_parcels", "graphicsLogoLayer"].includes(layer.graphic.layer?.id)
          );
          if (landParcelsResults.length > 0 && landParcelsResults[0]?.graphic?.attributes) {
            getParcel_CodFromF_Land_parcelsLayer =
              landParcelsResults[0].graphic.attributes.Parcel_Cod;
            logoId = landParcelsResults[0].graphic.attributes.logoId;
          }

          const pointDataEnvelope: PointDataEnvelope = (
            await getPointDataWithTokenRefresh(
              returnedData.mapPoint.longitude,
              returnedData.mapPoint.latitude
            )
          ).data;
          const pointResult = pointDataEnvelope.data.result;

          if (!pointResult || pointResult == null || pointResult.geometry == null || pointResult.geometry.rings == null) {
            uiState.setIsLoading(false);
            errorState.setErrorTitle("خطأ في العثور على القطعة");
            errorState.setErrorMessage(`لا يمكن العثور علي القطعه المعلن عنها| {x: ${returnedData.mapPoint.longitude}, y: ${returnedData.mapPoint.latitude}} الرجاء المحاولة لاحقًا`);
            openpErrorModal();

            return;
          }
          let rings: any = pointResult.geometry.rings;

          const attributes: any = {};
          attributes["Land_Numbe"] = pointResult.parcelNo;
          attributes["Parcel_Cod"] = pointResult.objectId;
          attributes["NK"] = pointResult.city;
          attributes["DK"] = pointResult.districtName;
          attributes["ZK"] = pointResult.region;

          let pPolygongraphic: any = createFeatureGraphics(
            "polygon",
            rings,
            4326,
            attributes,
            selectedSymbolElshamalya
          );
          //console.log("pPolygongraphic", pPolygongraphic);


          featureState.setCurrentSelectedFeatures(returnedData.results);
          featureState.setSelectedFeature(pPolygongraphic);

          if (pointResult) {
            let plot = pointResult;

            let parcel_Cod: string | undefined;
            if (getParcel_CodFromF_Land_parcelsLayer) {
              parcel_Cod = getParcel_CodFromF_Land_parcelsLayer;
            } else {
              parcel_Cod = pointResult.objectId;
            }

            // //console.log("plot", plot);
            if (parcel_Cod) {
              getNhcIntegrationByObjIdFunction(parcel_Cod)
                .then(async (returnedNhcIntegrationData: any) => {
                  //console.log("returnedNhcIntegrationDa ta===>", returnedNhcIntegrationData);

                  if (returnedNhcIntegrationData.data.length > 0) {
                    propertyDataState.setPropertyAdvertisements(returnedNhcIntegrationData.data);
                  } else {
                    propertyDataState.setPropertyAdvertisements([]);
                  }

                  locationState.setdistrict_Name(
                    plot.districtName == null
                      ? ""
                      : plot.districtName
                  );
                  locationState.setregion_Name(
                    plot.region == null
                      ? ""
                      : plot.region
                  );
                  locationState.setcity_Name(
                    plot.city == null
                      ? ""
                      : plot.city
                  );
                  logoState.setObjectId(parcel_Cod);
                  logoState.setMapObjectId(pointResult.objectId);
                  featureState.setProperty(plot);
                  logoState.setParcel_Cod(parcel_Cod);
                  logoState.setLogoId(logoId);
                  formState.setPropertyNumber(plot.parcelNo ?? "");
                  // //console.log("plot data", plot);
                  formState.setLandAddress(`${(plot.region && plot.region !== "Null") ? plot.region : "__"
                    } | ${(plot.city && plot.city !== "Null") ? plot.city : "__"
                    } | ${(plot.districtName && plot.districtName !== "Null") ? plot.districtName : "__"
                    } | المخطط: 
                     ${(plot.planNO && plot.planNO !== "Null") ? plot.planNO : "__"
                    } | القطعة:  ${(plot.parcelNo && plot.parcelNo !== "Null") ? plot.parcelNo : "__"
                    }`);
                  // setLandAddress(`${plot.districtName == null ? "__" : plot.districtName} / ${plot.city == null ? "__" : plot.city} /
                  //   ${plot.region == null ? "__" : plot.region}`);
                  // //console.log("landAddress", formState.landAddress);

                  logoState.setParcelNumber(
                    plot.parcelNo == null
                      ? ""
                      : plot.parcelNo
                  );
                  logoState.setSUBDIVISIONPLAN_ID(
                    plot.planNO == null
                      ? ""
                      : plot.planNO
                  );
                  setTimeout(() => {
                    // Check for favorite land features
                    let isHaveF_FavoriteLand: any[] = [];
                    if (returnedData && returnedData.results.length > 0) {
                      isHaveF_FavoriteLand = returnedData.results.filter(
                        (geLayer: any) => geLayer.graphic.layer?.id == "F_FavoriteLand"
                      );
                    }
                    if (isHaveF_FavoriteLand.length <= 0) {
                      uiState.setPropertyModalIsOpen(true);
                    }
                    uiState.setIsLoading(false);
                  }, 1000);
                })
                .catch((error: any) => {
                  uiState.setIsLoading(false);
                  errorState.setErrorTitle("خطأ في تحميل البيانات");
                  errorState.setErrorMessage("حدث خطأ في تحميل بيانات العقار المختار !");
                  openpErrorModal();
                  // //console.log(error);
                });
            }
          }
        }

        // Check for favorite land features
        if (returnedData && returnedData.results.length > 0) {
          const isHaveF_FavoriteLand = returnedData.results.filter(
            (geLayer: any) => geLayer.graphic.layer?.id == "F_FavoriteLand"
          );
          // //console.log("isHaveF_FavoriteLand", isHaveF_FavoriteLand);

          if (isHaveF_FavoriteLand.length > 0) {
            let ParcelCode = isHaveF_FavoriteLand[0].graphic.attributes.ParcelCode;
            console.log("ParcelCode isHaveF_FavoriteLand", ParcelCode);
            getFavoriteLandByParcCodeFunction(
              Number(ParcelCode)
            )
              .then(async (returnedData: any) => {
                console.log("returnedData isHaveF_FavoriteLand", returnedData);

                propertyDataState.setPropertyFavoriteLand(returnedData.data);
                setTimeout(() => {
                  uiState.setFavoriteLandByParcCodeModalIsOpen(true);
                }, 1000);
              })
              .catch((error: any) => {
                uiState.setIsLoading(false);
                errorState.setErrorTitle("خطأ في تحميل البيانات");
                errorState.setErrorMessage("حدث خطأ في تحميل بيانات الوحدة المفضلة !");
                openpErrorModal();
                // //console.log(error);
              });
          }
        }
      });
    });

    // Store the click handler reference for potential removal during measurement
    plotDataClickHandlerRef.current = clickHandler;
  };


  //model property
  const [presentAddProperty, dismisAddProperty] = useIonModal(
    AddPropertyNhcIntegration,
    {
      dismisAddProperty: (data: string, role: string) =>
        dismisAddProperty(data, role),
    }
  );

  function openpAddPropertyModal() {
    presentAddProperty({
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }

  let getCitiesOfRegion = (selectedRegion: any) => {
    mapFunctions.handleGetCities(selectedRegion, uiState.setIsLoading, dataArraysState.setCities, presentToastFunction, presentToast);
  };

  let getDistrictOfCity = (selectedRegion: string, selectedCity: string) => {
    mapFunctions.handleGetDistricts(selectedRegion, selectedCity, uiState.setIsLoading, dataArraysState.setDistricts, presentToastFunction, presentToast);
  };

  let getPlans = (selectedRegion: string, selectedCity: string, selectedDistrict: string) => {
    mapFunctions.handleGetPlans(selectedRegion, selectedCity, selectedDistrict, uiState.setIsLoading, dataArraysState.setPlans, presentToastFunction, presentToast);
  };

  let getParcels = (selectedRegion: string, selectedCity: string, selectedDistrict: string, planNo: string) => {
    mapFunctions.handleGetParcels(selectedRegion, selectedCity, selectedDistrict, planNo, uiState.setIsLoading, dataArraysState.setParcels, presentToastFunction, presentToast);
  };

  let REGA_20MapServiceURL = arcgisServicesLandFeatureUrl + "1/query";
  let getGraphicFromObj = (obj: any) => {
    let queryOption: any = {
      responseType: "json",
      query: {
        f: "json",
        where: `ParcelCode in (${obj}) `,
        returnCountOnly: false,
        outFields: "*",
        returnDistinctValues: false,
        returnGeometry: true,
      },
    };
    Request(REGA_20MapServiceURL, queryOption)
      .then((response: any) => {
        if (response.data.features.length >= 0) {
          mapLogic.zoomToLayer(
            "polygon",
            response.data.features[0].geometry.rings,
            4326,
            false
          );
          uiState.setIsLoading(false);
        } else {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `يرجى التاكد من رقم القطعة`
          );
        }
      })
      .catch((error: any) => { });
  };

  // Load user data on app initialization
  useEffect(() => {
    // Only fetch if user is authenticated and has userInfo
    if (authenticationState === "authenticated" && userInfo?.id && token) {
      GetUserFunction(userInfo.id, token)
        .then((returnedData) => {
          try {
            const fetchedUserData = returnedData.data.dateSet;
            console.log("User data loaded successfully:", fetchedUserData);

            // Update Redux state with fresh user data
            dispatch(setUserInfo(fetchedUserData));

            // Update localStorage
            const persistantState = localStorage.getItem("persistantState");
            if (persistantState) {
              const parsedState = JSON.parse(persistantState);
              parsedState.userInfo = fetchedUserData;
              localStorage.setItem("persistantState", JSON.stringify(parsedState));
              console.log("Updated userInfo in Redux and localStorage");
            }
          } catch (error) {
            console.error("Error processing user data:", error);
            presentToastFunction(
              presentToast,
              "top",
              "danger",
              "حدث خطأ في معالجة بيانات المستخدم"
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            "حدث خطأ في تحميل بيانات المستخدم"
          );
        });
    }
  }, [authenticationState, userInfo?.id, token]); // Re-run if authentication state or user ID changes


  useEffect(() => {
    if (searchState.isModalOpen == "region") {
      searchState.setFilteredData(
        dataArraysState.regions.filter(
          (item: any) =>
            item &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchState.searchQuery.toString().toLowerCase())
        )
      );
    }
    if (searchState.isModalOpen == "city") {
      searchState.setFilteredData(
        dataArraysState.cities.filter(
          (item: any) =>
            item &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchState.searchQuery.toString().toLowerCase())
        )
      );
    }
    if (searchState.isModalOpen == "district") {
      searchState.setFilteredData(
        dataArraysState.districts.filter(
          (item: any) =>
            item &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchState.searchQuery.toString().toLowerCase())
        )
      );
    }
    if (searchState.isModalOpen == "plan") {
      searchState.setFilteredData(
        dataArraysState.plans.filter(
          (item: any) =>
            item &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchState.searchQuery.toString().toLowerCase())
        )
      );
    }
    if (searchState.isModalOpen === "parcel") {
      const query = searchState.searchQuery.toString().toLowerCase();

      // First try by key (exact match)
      let results = dataArraysState.parcels.filter(
        (item: any) => item && item.key.toString().toLowerCase().includes(query)
      );

      // If nothing found, fallback to name (partial match)
      if (results.length === 0) {
        results = dataArraysState.parcels.filter(
          (item: any) =>
            item &&
            item.name.toString().toLowerCase().includes(query)
        );
      }

      searchState.setFilteredData(results);
    }

  }, [searchState.searchQuery, searchState.isModalOpen]); // Re-run the effect if searchQuery or isModalOpen changes

  const handleSearch = (event: CustomEvent) => {
    const value = (event.target as HTMLInputElement).value || "";
    searchState.setSearchQuery(value);
  };

  const handleSelectItem = async (selectedItem: any) => {

    if (searchState.isModalOpen == "region") {
      try {
        uiState.setIsLoading(true);
        formState.setSelectedRegion({
          name: selectedItem.name,
          key: selectedItem.key,
        });
        formState.setSelectedCity({ name: "", key: "" });
        formState.setSelectedDistrict({ name: "", key: "" });
        formState.setSelectedPlan({ name: "", key: "" });
        formState.setSelectedParcel({ name: "", key: "" });
        const token = await getBaladyAccessToken();
        const regionData = await getRegionDataByCode(selectedItem.key, token);
        zoomToLayer("polygon", regionData.data.data.result[0].rings, 4326, false);

        dataArraysState.setCities([]);
        getCitiesOfRegion(selectedItem.key);
        dataArraysState.setDistricts([]);
        dataArraysState.setPlans([]);
        dataArraysState.setParcels([]);
      } catch (error) {
        console.error("Error selecting region:", error);
        uiState.setIsLoading(false);
        errorState.setErrorTitle("خطأ في تحميل البيانات");
        errorState.setErrorMessage(`حدث خطأ في تحميل بيانات المنطقة المختارة! - ${(error as any).response.data.data.responseMessage}`);
        openpErrorModal();
        return;
      }
    }
    if (searchState.isModalOpen == "city") {
      try {
        uiState.setIsLoading(true);
        formState.setSelectedCity({
          name: selectedItem.name,
          key: selectedItem.key,
        });
        formState.setSelectedDistrict({ name: "", key: "" });
        formState.setSelectedPlan({ name: "", key: "" });
        formState.setSelectedParcel({ name: "", key: "" });
        let graphicResult = dataArraysState.cities.filter((item: any) => {
          return item.key === selectedItem.key;
        });
        zoomToLayer("polygon", graphicResult[0].graphic.rings, 4326, false);
        dataArraysState.setDistricts([]);
        getDistrictOfCity(formState.selectedRegion.key, selectedItem.key);
        dataArraysState.setPlans([]);
        dataArraysState.setParcels([]);
      } catch (error) {
        console.error("Error selecting city:", error);
        uiState.setIsLoading(false);
        errorState.setErrorTitle("خطأ في تحميل البيانات");
        errorState.setErrorMessage(`حدث خطأ في تحميل بيانات المدينة المختارة! -  ${(error as any).response.data.data.responseMessage}`);
        openpErrorModal();
        return;
      }
    }
    if (searchState.isModalOpen == "district") {
      try {
        uiState.setIsLoading(true);
        formState.setSelectedDistrict({
          name: selectedItem.name,
          key: selectedItem.key,
        });
        formState.setSelectedPlan({ name: "", key: "" });
        formState.setSelectedParcel({ name: "", key: "" });
        let graphicResult = dataArraysState.districts.filter((item: any) => {
          return item.key === selectedItem.key;
        });
        zoomToLayer("polygon", graphicResult[0].graphic.rings, 4326, false);
        // await getSubDivisionPlanS(graphicResult[0].graphic);
        getPlans(formState.selectedRegion.key, formState.selectedCity.key, selectedItem.key);
        dataArraysState.setParcels([]);
      } catch (error) {
        console.error("Error selecting district:", error);
        uiState.setIsLoading(false);
        errorState.setErrorTitle("خطأ في تحميل البيانات");
        errorState.setErrorMessage(`حدث خطأ في تحميل بيانات الحي المختار! - ${(error as any).response.data.data.responseMessage}`);
        openpErrorModal();
        return;
      }
    }
    if (searchState.isModalOpen == "plan") {
      try {
        uiState.setIsLoading(true);
        formState.setSelectedPlan({
          name: selectedItem.name,
          key: selectedItem.key,
        });
        formState.setSelectedParcel({ name: "", key: "" });

        let graphicResult = dataArraysState.plans.filter((item: any) => {
          return item.key === selectedItem.key;
        });
        zoomToLayer("polygon", graphicResult[0].graphic.rings, 4326, false);
        getParcels(formState.selectedRegion.key, formState.selectedCity.key, formState.selectedDistrict.key, selectedItem.key);
      } catch (error) {
        console.error("Error selecting plan:", error);
        uiState.setIsLoading(false);
        errorState.setErrorTitle("خطأ في تحميل البيانات");
        errorState.setErrorMessage(`حدث خطأ في تحميل بيانات المخطط المختار! -  ${(error as any).response.data.data.responseMessage}`);
        openpErrorModal();
        return;
      }
    }
    if (searchState.isModalOpen == "parcel") {
      try {
        uiState.setIsLoading(true);
        formState.setSelectedParcel({
          name: selectedItem.name,
          key: selectedItem.key,
        });

        let graphicResult = dataArraysState.parcels.filter((item: any) => {
          return item.key === selectedItem.key;
        });
        zoomToLayer("polygon", graphicResult[0].graphic.rings, 4326, false);
        uiState.setIsLoading(false);
      } catch (error) {
        console.error("Error selecting parcel:", error);
        uiState.setIsLoading(false);
        errorState.setErrorTitle("خطأ في تحميل البيانات");
        errorState.setErrorMessage(`حدث خطأ في تحميل بيانات القطعة المختارة! -  ${(error as any).response.data.data.responseMessage}`);
        openpErrorModal();
        return;
      }
    }

    searchState.setIsModalOpen("");
    searchState.setSearchQuery("");
  };

  function checkIfEstateBroker() {
    const parts = window.location.pathname.split("/");
    const result = parts.splice(3, parts.length).join("");
    propertyDataState.setEstateBrokersById(result);
    openEstateBrokersByIdModal();
  }

  useEffect(() => {
    if (featureState.getLogosData && mapLogic.graphicsLogoLayer) {
      mapLogic.graphicsLogoLayer.removeAll();
      featureState.getLogosData.forEach((item: any) => {
        if (item.isActive) {
          if (item.type == "logoAdd") {
            generateLogos(
              item.type,
              item.id,
              item.logoFile,
              Number(item.longitude) - 0.00004,
              Number(item.latitude) + 0.00005,
              `${item.height}px`,
              `${item.height}px`
            );
          } else {
            generateLogos(
              item.type,
              item.id,
              item.logoFile,
              Number(item.longitude) - 0.00004,
              Number(item.latitude) + 0.00005,
              `${item.height}px`,
              `${item.height}px`
            );
          }
        }
      });
    }
  }, [featureState.getLogosData, mapLogic.graphicsLogoLayer]);

  useEffect(() => {
    // Call getBuildingsWalletFuncData after map is ready and graphicsbuildingsWalletLayer is loaded
    if (mapLogic.graphicsbuildingsWalletLayer) {
      getBuildingsWalletFuncData();
    }
  }, [mapLogic.graphicsbuildingsWalletLayer]);

  // Cleanup measurement mode when tracking mode changes
  useEffect(() => {
    if (uiState.trackingModalMode) {
      clearMeasurement();
    }
  }, [uiState.trackingModalMode]);

  async function addStop(event: any) {
    // //console.log("event==>", event);

    // Clear previous route before adding new stops
    if (mapLogic.routeLayer) {
      mapLogic.routeLayer.removeAll();
    }
    routeParams.stops.features = [];

    // Add a point at the location of the map click
    const stop = new Graphic({
      geometry: event.mapPoint != null ? event.mapPoint : event.geometry,
      symbol: event.mapPoint != null ? stopTextSymbol : startTextSymbol,
    });

    mapLogic.routeLayer.add(stop);

    // Execute the route if 2 or more stops are input
    routeParams.stops.features.push(stop);
    if (routeParams.stops.features.length >= 2) {
      route.solve(routeUrl, routeParams).then(showRoute);
    } else {
      // //console.log("try to get currentLocation");
      let chcekPremission = await Geolocation.checkPermissions();
      // //console.log("chcekPremission", chcekPremission);
      if (
        chcekPremission.coarseLocation != "denied" &&
        chcekPremission.location != "denied"
      ) {
        let currentLocation: any;
        try {
          currentLocation = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 1000000,
          });
          // //console.log("currentLocation", currentLocation);
        } catch (err: any) {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            "يرجي تفعيل تحديد الموقع : " + err.message);
          uiState.setIsLoading(false);
          return;
        }

        let pointDegrees: any = {
          type: "point",
          longitude: currentLocation.coords.longitude,
          latitude: currentLocation.coords.latitude,
        };

        let symbol: any = {
          type: "simple-marker",
          size: "16px",
          color: "#0031C4",
          outline: {
            color: "#77A4D2",
            width: "3px",
          },
        };

        let pointGraphicForLocation = new Graphic({
          geometry: pointDegrees,
          symbol: symbol,
        });

        addStop(pointGraphicForLocation);
      } else {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          "يرجي تفعيل تحديد الموقع : ");
        uiState.setIsLoading(false);
        return;
      }
    }
  }


  let initMapFunction = async () => {
    try {
      const mapSystem = await mapLogic.initializeMap("viewDivMap");

      if (mapSystem) {
        mapLogic.MapViewData = mapSystem.MapViewData;
        window.mapviews = mapLogic.MapViewData;
        window.map = mapLogic.map;

        // Set up map watchers and localStorage functionality
        mapLogic.MapViewData.watch("scale", (evt) => {
          // Store current map state in localStorage
          localStorage.setItem("CurrentLatitude", mapLogic.MapViewData.center.latitude.toString());
          localStorage.setItem("CurrentLongitude", mapLogic.MapViewData.center.longitude.toString());
          localStorage.setItem("CurrentScale", evt.toString());
        });

        // Restore position from localStorage
        const savedLat = localStorage.getItem("CurrentLatitude");
        const savedLng = localStorage.getItem("CurrentLongitude");
        const savedScale = localStorage.getItem("CurrentScale");

        if (savedLat) mapLogic.MapViewData.center.latitude = Number(savedLat);
        if (savedLng) mapLogic.MapViewData.center.longitude = Number(savedLng);
        if (savedScale) mapLogic.MapViewData.scale = Number(savedScale);

        getPlotData();

        // Set initial layer visibility based on button states
        mapLogic.toggleFavoriteIcons(uiState.showFavoriteIcons);
        if (uiState.mapAds.length > 0) {
          mapLogic.applyOfferFilters(uiState.mapAds, offerSelection);
        }
        mapLogic.toggleWalletIcons(uiState.showWalletIcons);

        setTimeout(() => {
          //console.log("handleAnimationEffect===>");
          mapFunctions.handleAnimationEffect(mapLogic.MapViewData);
        }, 5000);
      }

    } catch (error) {
      console.error('Error initializing map:', error);
    }
  };

  async function changeFlashLightFeature() {
    if (featureState.property && featureState.selectedFeature) {
      uiState.setIsLoading(true);
      let featureFalsh =
        featureState.selectedFeature?.attributes?.Feature_Ad == "null" ||
          featureState.selectedFeature?.attributes?.Feature_Ad == null ||
          featureState.selectedFeature?.attributes?.Feature_Ad == "" ||
          featureState.selectedFeature?.attributes?.Feature_Ad == "false"
          ? "true"
          : "false";

      //console.log("selectedFeature", featureState.selectedFeature);
      //console.log("currentSelectedFeatures", featureState.currentSelectedFeatures);

      let isHaveFlashLand = featureState.currentSelectedFeatures.filter(
        (geLayer: any) => geLayer.graphic.attributes?.Feature_Ad == "true"
      );
      // //console.log("changeFlashLightFeature==>isHaveFlashLand", isHaveFlashLand);
      if (isHaveFlashLand.length > 0) {
        let getHaveFlashLand = isHaveFlashLand[0].graphic;
        // //console.log(
        //   "getHaveFlashLand.attributes.OBJECTID",
        //   getHaveFlashLand.attributes.OBJECTID
        // );
        let deleteFeatures = [];
        deleteFeatures.push({ objectId: getHaveFlashLand.attributes.OBJECTID });
        window.F_Land_parcels.applyEdits({
          deleteFeatures: deleteFeatures,
        }).then((result: any) => {
          // //console.log("delete result", result);
          if (result.deleteFeatureResults[0].error == null) {
            presentToastFunction(
              presentToast,
              "top",
              "success",
              `تم الفاء تحويل القطعه رقم ${featureState.property?.parcelNo || ""}`
            );
            window.F_Land_parcels.refresh();
            uiState.setIsLoading(false);
          } else {
            uiState.setIsLoading(false);
            errorState.setErrorTitle("خطأ في تحميل البيانات");
            errorState.setErrorMessage("يرجى اختيار القطعه ");
            openpErrorModal();
          }
        });
      } else {
        // //console.log(
        //   "selectedFeature.attributes.CITYNAME_AR",
        //   featureState.selectedFeature?.attributes?.CITYNAME_AR
        // );

        const attributes: any = {};
        attributes["Feature_Ad"] = featureFalsh;
        attributes["Parcel_Cod"] = `${featureState.selectedFeature?.attributes?.Parcel_Cod || ""}`;
        attributes["ZK"] =
          featureState.selectedFeature?.attributes?.ZK == null
            ? ""
            : featureState.selectedFeature?.attributes?.ZK;
        attributes["DK"] =
          featureState.selectedFeature?.attributes?.DK == null
            ? ""
            : featureState.selectedFeature?.attributes?.DK;
        attributes["NK"] =
          featureState.selectedFeature?.attributes?.NK == null
            ? ""
            : featureState.selectedFeature?.attributes?.NK;
        attributes["Land_Numbe"] =
          featureState.selectedFeature?.attributes?.Land_Numbe == null
            ? ""
            : featureState.selectedFeature?.attributes?.Land_Numbe;


        const geometryParcel: any = featureState.selectedFeature?.geometry ? new Polygon({
          rings: featureState.selectedFeature.geometry.rings,
          spatialReference: featureState.selectedFeature.geometry.spatialReference || { wkid: 4326 }
        }) : null;


        const addFeature = new Graphic({
          geometry: geometryParcel,
          attributes: attributes,
        });

        window.F_Land_parcelsFlashLight.applyEdits({ addFeatures: [addFeature] }).then(
          (response: any) => {
            // //console.log("response", response);
            if (response.addFeatureResults[0].error == null) {
              presentToastFunction(
                presentToast,
                "top",
                "success",
                `تم تحويل القطعه رقم ${featureState.property?.parcelNo || ""}`
              );
              window.F_Land_parcelsFlashLight.refresh();
              uiState.setIsLoading(false);
            } else {
              uiState.setIsLoading(false);
              errorState.setErrorTitle("خطأ في تحميل البيانات");
              errorState.setErrorMessage("يرجى اختيار القطعه ");
              openpErrorModal();
            }
          }
        );
      }
    }
  }

  async function changeFavoriteLandFeature(pPointgraphic: any) {
    if (featureState.property) {
      uiState.setIsLoading(true);
      // //console.log("selectedFeature", featureState.selectedFeature);
      // //console.log("currentSelectedFeatures", featureState.currentSelectedFeatures);

      let attributes = {
        ParcelCode: `${logoState.parcel_Cod}`,
        City_Name: locationState.city_Name,
        region_Name: locationState.region_Name,
        district_Name: locationState.district_Name,
        Land_Numbe: formState.propertyNumber,
      };

      const centroid = featureState.selectedFeature?.geometry ? getPolygonCenterPoint(featureState.selectedFeature.geometry as any) : null;
      const pointGeometry = new Point({
        x: centroid?.x || 0,
        y: centroid?.y || 0,
        spatialReference: featureState.selectedFeature?.geometry?.spatialReference
      });

      const addFeature = new Graphic({
        geometry: pointGeometry,
        attributes: attributes,
      });

      // //console.log("addFeature", addFeature);

      window.F_FavoriteLand.applyEdits({ addFeatures: [addFeature] }).then(
        (response: any) => {
          // //console.log("response", response);
          if (response.addFeatureResults[0].error == null) {
            // //console.log(
            //   "response.addFeatureResults",
            //   response.addFeatureResults[0].objectId
            // );


          }
        }
      );
    }
  }

  function deletePoint(objId: any) {
    window.F_FavoriteLand.applyEdits({
      deleteFeatures: [{ objectId: objId }],
    }).then((result: any) => {
      if (result.deleteFeatureResults[0].error == null) {
      } else {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          "خطئ عند رجوع البيانات الجغرافيه لوضعها الطبيعي"
        );
      }
    });
  }

  let handleRemoveLogos = (id: any) => {
    mapFunctions.handleRemoveLogos(id, featureState.getLogosData, featureState.SetGetLogosData);
  };

  function generatetBuildingsWalletFuncLogos(
    id: any,
    longitude: any,
    latitude: any,
    parcel_Cod: any,
    land_Numbe: any,
    title: any
  ) {
    mapFunctions.handleGenerateBuildingsWalletLogos(
      id,
      longitude,
      latitude,
      parcel_Cod,
      land_Numbe,
      title,
      mapLogic.graphicsbuildingsWalletLayer
    );
  }

  function generateLogos(
    type: any,
    id: any,
    file: any,
    longitude: any,
    latitude: any,
    width: any,
    height: any
  ) {
    mapFunctions.handleGenerateLogos(
      type,
      id,
      file,
      longitude,
      latitude,
      width,
      height,
      mapLogic.graphicsLogoLayer,
      mapLogic.graphicsLogoLayerlogoAdd,
      mapLogic.MapViewData
    );
  }

  async function getLogoData() {
    let rresultData = await getLogosDataFunction();
    featureState.SetGetLogosData(rresultData.data);
  }

  useEffect(() => {
    getLogoData();
    getRegions(uiState.setIsLoading, dataArraysState.setRegions, presentToastFunction, presentToast);
    if (userInfo?.roles?.some((r: any) => ["admin"].includes(r))) {
      userRoleState.setIsAdmin(true);
    }
    if (userInfo?.roles?.some((r: any) => ["user"].includes(r))) {
      userRoleState.setIsUser(true);
    }
    if (userInfo?.roles?.some((r: any) => ["operation"].includes(r))) {
      userRoleState.setIsOperation(true);
    }

    getAPPVersionsInfo();
  }, []);

  const logDeviceInfo = async () => {
    const info = await Device.getInfo();
    return info;
  };

  const logBatteryInfo = async () => {
    const info = await Device.getBatteryInfo();
    return info;
  };

  function presentAlertUpdateApp(url: any) {
    return presentAlert({
      cssClass: "animate__animated animate__fadeInDown",
      header: "تنبية",
      message: `<strong class="strongStyle">يرجي تحديث تطبيق ذكي من المتجر ؟ </strong >`,
      buttons: [
        {
          text: "موافق",
          role: "confirm",
          handler: () => {
            window.open(`${url}`, "_blank", "noopener,noreferrer");
          },
        },
      ],
      backdropDismiss: false,
      onDidDismiss: () => {
        // //console.log("presentAlertUpdateApp onDidDismiss");
      },
    });
  }
  const getAPPVersionsInfo = async () => {
    getAPPVersionsFunction()
      .then(async (getAPPVersions: any) => {
        // //console.log("getAPPVersionsFunction==>getAPPVersions", getAPPVersions);
        //let deInfo = await logDeviceInfo();
        // //console.log("isPlatform", isPlatform("ios"));

        // let batInfo = await logBatteryInfo();
        // //console.log("batInfo==>", batInfo);
        if (isPlatform("ios")) {
          // //console.log("IOSVersion", IOSVersion);
          // //console.log(
          //   "Number(getAPPVersions.data.iosVersion)",
          //   Number(getAPPVersions.data.iosVersion)
          // );
          if (Number(getAPPVersions.data.iosVersion) > IOSVersion) {
            //need popup to goto apple store
            // //console.log("old version");
            setTimeout(() => {
              presentAlertUpdateApp("https://thki.sa/ios");
            }, 20000);
          }
        } else if (isPlatform("android")) {
          // //console.log("AndoridVersion", AndoridVersion);
          // //console.log(
          //   "Number(getAPPVersions.data.andoridVersion)",
          //   Number(getAPPVersions.data.andoridVersion)
          // );
          if (Number(getAPPVersions.data.andoridVersion) > AndoridVersion) {
            //need popup to goto andorid store
            setTimeout(() => {
              presentAlertUpdateApp("https://thki.sa/android");
            }, 20000);
          }
        }
      })
      .catch((e) => {
        // //console.log(e);
      });
  };

  useEffect(() => {
    if (
      location?.pathname &&
      (location.pathname.includes("app") ||
        location.pathname.includes("app/")) &&
      !location.pathname.includes("estateBrokers") &&
      !location.pathname.includes("PaymentRedirect")
    ) {
      const pathParts = location.pathname.split('/');
      if (pathParts.length >= 4 && pathParts[1] === 'app' && !pathParts[2].includes('d')) {
        const longitude = parseFloat(pathParts[2]);
        const latitude = parseFloat(pathParts[3]);

        if (!isNaN(longitude) && !isNaN(latitude)) {
          // //console.log("Extracted coordinates:", { longitude, latitude });

          const waitForMapView = () => {
            return new Promise<void>((resolve) => {
              const checkMapView = () => {
                if (mapLogic.MapViewData) {
                  // //console.log("MapViewData is ready");
                  resolve();
                } else {
                  // //console.log("Waiting for MapViewData to initialize...");
                  setTimeout(checkMapView, 100);
                }
              };
              checkMapView();
            });
          };

          waitForMapView().then(async () => {
            mapLogic.MapViewData.goTo({
              center: [longitude, latitude],
              zoom: 18
            });

            // //console.log("finish goto zoom from MapViewData");

            // Get objectId from F_Land_parcels layer similar to getPlotData()
            const pointGeometry = new Point({
              x: longitude,
              y: latitude,
              spatialReference: { wkid: 4326 }
            });

            const queryFeaturesAtPoint = async () => {
              const query = new Query({
                geometry: pointGeometry,
                spatialRelationship: "intersects",
                returnGeometry: true,
                outFields: ["*"],
                distance: 0,
                units: "meters"
              });

              const results = await mapLogic.MapViewData.map.layers
                .filter((layer: any) => layer.id === "F_Land_parcels")
                .map(async (layer: any) => {
                  try {
                    const featureSet = await layer.queryFeatures(query);
                    return {
                      graphic: featureSet.features[0],
                      layer: layer
                    };
                  } catch (error) {
                    console.error(`Error querying layer ${layer.id}:`, error);
                    return null;
                  }
                });

              const validResults = (await Promise.all(results)).filter(result => result !== null);
              return { results: validResults, mapPoint: pointGeometry };
            };

            // Get objectId from F_Land_parcels layer
            let getParcel_CodFromF_Land_parcelsLayer: string | undefined;
            try {
              const returnedData = await queryFeaturesAtPoint();
              if (returnedData && returnedData.results.length > 0) {
                const landParcelsResults = returnedData.results.filter(
                  (layer: any) => layer.graphic.layer?.id === "F_Land_parcels"
                );
                if (landParcelsResults.length > 0 && landParcelsResults[0]?.graphic?.attributes) {
                  getParcel_CodFromF_Land_parcelsLayer =
                    landParcelsResults[0].graphic.attributes.Parcel_Cod;
                }
              }
            } catch (error) {
              console.error("Error getting objectId from F_Land_parcels:", error);
            }

            const pointDataEnvelope: PointDataEnvelope = (
              await getPointDataWithTokenRefresh(
                longitude.toString(),
                latitude.toString()
              )
            ).data;

            // const pointGeometry = new Point({
            //   x: longitude,
            //   y: latitude,
            //   spatialReference: { wkid: 4326 }
            // });

            // const markerSymbol = new PictureMarkerSymbol({
            //   url: googlePinIcon,
            //   width: "48px",
            //   height: "48px",
            // });

            // const markerGraphic = new Graphic({
            //   geometry: pointGeometry,
            //   symbol: markerSymbol
            // });

            const polygonGeometry = new Polygon({
              rings: pointDataEnvelope.data.result.geometry.rings,
              spatialReference: { wkid: 4326 }
            });

            const polygonSymbol = {
              type: "simple-fill",
              color: [34, 197, 94, 0.4],
              outline: {
                color: [0, 0, 0, 1],
                width: 1
              }
            };

            const polygonGraphic = new Graphic({
              geometry: polygonGeometry,
              symbol: polygonSymbol
            });

            mapLogic.MapViewData.graphics.removeAll();
            mapLogic.MapViewData.graphics.add(polygonGraphic);


            setTimeout(async () => {
              try {
                const pointResult = pointDataEnvelope.data.result;

                if (pointResult) {
                  uiState.setIsLoading(true);
                  let plot = pointResult;

                  // Use objectId from F_Land_parcels layer if available, otherwise use pointResult.objectId
                  let parcel_Cod: string | undefined;
                  if (getParcel_CodFromF_Land_parcelsLayer) {
                    parcel_Cod = getParcel_CodFromF_Land_parcelsLayer;
                  } else {
                    parcel_Cod = pointResult.objectId;
                  }

                  if (parcel_Cod) {
                    featureState.setProperty(plot);
                    getNhcIntegrationByObjIdFunction(parcel_Cod)
                      .then(async (returnedData: any) => {
                        if (returnedData.data.length > 0) {
                          propertyDataState.setPropertyAdvertisements(returnedData.data);
                        } else {
                          propertyDataState.setPropertyAdvertisements([]);
                        }

                        locationState.setdistrict_Name(plot.districtName || "");
                        locationState.setregion_Name(plot.region || "");
                        locationState.setcity_Name(plot.city || "");
                        logoState.setObjectId(parcel_Cod);
                        logoState.setParcel_Cod(parcel_Cod);
                        formState.setPropertyNumber(
                          plot.parcelNo == null
                            ? ""
                            : plot.parcelNo
                        );
                        locationState.setCurrentLongitude(longitude);
                        locationState.setCurrentLatitude(latitude);

                        formState.setLandAddress(`${(plot.region && plot.region !== "Null") ? plot.region : "__"
                          } | ${(plot.city && plot.city !== "Null") ? plot.city : "__"
                          } | ${(plot.districtName && plot.districtName !== "Null") ? plot.districtName : "__"
                          } | المخطط: 
                           ${(plot.planNO && plot.planNO !== "Null") ? plot.planNO : "__"
                          } | القطعة:  ${(plot.parcelNo && plot.parcelNo !== "Null") ? plot.parcelNo : "__"
                          }`);

                        logoState.setParcelNumber(plot.parcelNo || "");
                        logoState.setSUBDIVISIONPLAN_ID(plot.planNO || "");

                        setTimeout(() => {
                          uiState.setPropertyModalIsOpen(true);
                          uiState.setIsLoading(false);
                        }, 1000);
                      })
                      .catch((error: any) => {
                        uiState.setIsLoading(false);
                        errorState.setErrorTitle("خطأ في تحميل البيانات");
                        errorState.setErrorMessage("حدث خطأ في تحميل بيانات العقار المختار !");
                        openpErrorModal();
                        // //console.log(error);
                      });
                  }
                }
              } catch (error) {
                // console.error("Error fetching property data for coordinates:", error);
                uiState.setIsLoading(false);
              }
            }, 1000);
          });
          return;
        }
      }


      if (location.pathname.includes("app/d/")) {

        const pathParts = location.pathname.split('/');
        if (pathParts.length >= 5 && pathParts[1] === 'app' && pathParts[2] === 'd') {
          const longitude = parseFloat(pathParts[3]);
          const latitude = parseFloat(pathParts[4]);

          if (!isNaN(longitude) && !isNaN(latitude)) {
            // //console.log("Extracted coordinates from detail URL:", { longitude, latitude });


            const waitForMapView = () => {
              return new Promise<void>((resolve) => {
                const checkMapView = () => {
                  if (mapLogic.MapViewData) {
                    // //console.log("MapViewData is ready for detail coordinates");
                    resolve();
                  } else {
                    // //console.log("Waiting for MapViewData to initialize for detail...");
                    setTimeout(checkMapView, 100);
                  }
                };
                checkMapView();
              });
            };

            waitForMapView().then(async () => {
              mapLogic.MapViewData.goTo({
                center: [longitude, latitude],
                zoom: 18
              });

              // //console.log("finish goto zoom from MapViewData for detail");

              const pointGeometry = new Point({
                x: longitude,
                y: latitude,
                spatialReference: { wkid: 4326 }
              });

              // Get objectId from F_Land_parcels layer similar to getPlotData()
              const queryFeaturesAtPoint = async () => {
                const query = new Query({
                  geometry: pointGeometry,
                  spatialRelationship: "intersects",
                  returnGeometry: true,
                  outFields: ["*"],
                  distance: 0,
                  units: "meters"
                });

                const results = await mapLogic.MapViewData.map.layers
                  .filter((layer: any) => layer.id === "F_Land_parcels")
                  .map(async (layer: any) => {
                    try {
                      const featureSet = await layer.queryFeatures(query);
                      return {
                        graphic: featureSet.features[0],
                        layer: layer
                      };
                    } catch (error) {
                      console.error(`Error querying layer ${layer.id}:`, error);
                      return null;
                    }
                  });

                const validResults = (await Promise.all(results)).filter(result => result !== null);
                return { results: validResults, mapPoint: pointGeometry };
              };

              // Get objectId from F_Land_parcels layer
              let getParcel_CodFromF_Land_parcelsLayer: string | undefined;
              try {
                const returnedData = await queryFeaturesAtPoint();
                if (returnedData && returnedData.results.length > 0) {
                  const landParcelsResults = returnedData.results.filter(
                    (layer: any) => layer.graphic.layer?.id === "F_Land_parcels"
                  );
                  if (landParcelsResults.length > 0 && landParcelsResults[0]?.graphic?.attributes) {
                    getParcel_CodFromF_Land_parcelsLayer =
                      landParcelsResults[0].graphic.attributes.Parcel_Cod;
                  }
                }
              } catch (error) {
                console.error("Error getting objectId from F_Land_parcels:", error);
              }

              const markerSymbol = {
                type: "simple-marker",
                style: "triangle",
                size: "28px",
                color: "#ff0000",
                outline: {
                  color: "#ffffff",
                  width: "2px"
                }
              };

              const markerGraphic = new Graphic({
                geometry: pointGeometry,
                symbol: markerSymbol
              });

              mapLogic.graphicsLayer.removeAll();
              mapLogic.graphicsLayer.add(markerGraphic);

              mapLogic.graphicsLayer.visible = true;

              mapLogic.MapViewData.graphics.add(markerGraphic);

              // //console.log("Detail marker added at coordinates:", { longitude, latitude });
              // //console.log("Graphics layer count:", mapLogic.graphicsLayer.graphics.length);

              setTimeout(async () => {
                try {
                  const pointDataEnvelope: PointDataEnvelope = (
                    await getPointDataWithTokenRefresh(
                      longitude.toString(),
                      latitude.toString()
                    )
                  ).data;
                  const pointResult = pointDataEnvelope.data.result;

                  if (pointResult) {
                    uiState.setIsLoading(true);
                    let plot = pointResult;

                    // Use objectId from F_Land_parcels layer if available, otherwise use pointResult.objectId
                    let parcel_Cod: string | undefined;
                    if (getParcel_CodFromF_Land_parcelsLayer) {
                      parcel_Cod = getParcel_CodFromF_Land_parcelsLayer;
                    } else {
                      parcel_Cod = pointResult.objectId;
                    }

                    if (parcel_Cod) {
                      featureState.setProperty(plot);
                      getNhcIntegrationByObjIdFunction(parcel_Cod)
                        .then(async (returnedData: any) => {
                          if (returnedData.data.length > 0) {
                            propertyDataState.setPropertyAdvertisements(returnedData.data);
                          } else {
                            propertyDataState.setPropertyAdvertisements([]);
                          }

                          locationState.setdistrict_Name(plot.districtName || "");
                          locationState.setregion_Name(plot.region || "");
                          locationState.setcity_Name(plot.city || "");
                          logoState.setObjectId(parcel_Cod);
                          logoState.setParcel_Cod(parcel_Cod);
                          formState.setPropertyNumber(plot.parcelNo || "");
                          locationState.setCurrentLongitude(longitude);
                          locationState.setCurrentLatitude(latitude);

                          formState.setLandAddress(`${(plot.region && plot.region !== "Null") ? plot.region : "__"
                            } | ${(plot.city && plot.city !== "Null") ? plot.city : "__"
                            } | ${(plot.districtName && plot.districtName !== "Null") ? plot.districtName : "__"
                            } | المخطط: 
                             ${(plot.planNO && plot.planNO !== "Null") ? plot.planNO : "__"
                            } | القطعة:  ${(plot.parcelNo && plot.parcelNo !== "Null") ? plot.parcelNo : "__"
                            }`);

                          formState.setPropertyNumber(plot.parcelNo || "");
                          logoState.setSUBDIVISIONPLAN_ID(plot.planNO || "");

                          setTimeout(() => {
                            uiState.setPropertyModalIsOpen(true);
                          }, 1000);
                        })
                        .catch((error: any) => {
                          uiState.setIsLoading(false);
                          errorState.setErrorTitle("خطأ في تحميل البيانات");
                          errorState.setErrorMessage("حدث خطأ في تحميل بيانات العقار المختار !");
                          openpErrorModal();
                          // //console.log(error);
                        });
                    }
                  }
                } catch (error) {
                  // console.error("Error fetching property data for detail coordinates:", error);
                  uiState.setIsLoading(false);
                }
              }, 1000);
            });
            return;
          }
        }


        let getUrlPar: any = Number(location.pathname.replace("/app/d/", ""));
        if (!Number.isNaN(getUrlPar) && !Number.isNaN(getUrlPar)) {
          window.location.assign(`/app/d?name=${getUrlPar}`);
        }
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const initializeMap = async () => {
      try {
        await initMapFunction();
      } catch (error) {
        // console.error('Error initializing map:', error);
      }
    };

    initializeMap();

    if (window.location.pathname.includes("estateBrokers")) {
      checkIfEstateBroker();
    }
  }, [location.pathname]);


  const [presentEstateBrokersModal, onCloseEstateBrokersDismiss] = useIonModal(
    EstateBrokersModal,
    {
      currentRegion: locationState.currentRegion,
      id: null,
      onCloseEstateBrokersDismiss: (data: string, role: string) =>
        onCloseEstateBrokersDismiss(data, role),
    }
  );
  const getRegionNameByGis = mapFunctions.handleGetRegionNameByGis;

  function openEstateBrokersModal() {
    uiState.setIsLoading(true);
    // //console.log("currentRegion", locationState.currentRegion);
    getRegionNameByGis(mapLogic.MapViewData, locationState.setCurrentRegion);
    presentEstateBrokersModal({
      animated: true,

      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
    uiState.setIsLoading(false);
  }


  const [presentEstateBrokersByIdModal, onCloseEstateBrokersByIdDismiss] =
    useIonModal(EstateBrokersModal, {
      currentRegion: null,
      id: propertyDataState.EstateBrokersById,
      onCloseEstateBrokersDismiss: (data: string, role: string) =>
        onCloseEstateBrokersByIdDismiss(data, role),
    });

  function openEstateBrokersByIdModal() {
    presentEstateBrokersByIdModal({
      animated: true,

      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "backdrop") {
          window.location.assign(`/app/home`);
        }
      },
    });
  }

  async function openAdvertisementModal(clickedItem: any) {
    // //console.log("Opening modal with advertisement:", clickedItem);

    try {
      const result = await getNhcIntegrationByAdLicenseNumberFunction(
        clickedItem.adLicenseNumber,
        clickedItem.idType,
        clickedItem.id
      );

      // //console.log("API response with addId:", result);

      if (result?.data?.data) {
        integrationState.setItemData(result.data.data);
        presentAdvertisementModal({
          onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
            if (ev.detail.role === "confirm") {
            }
          },
        });
      } else {
        console.warn("API call failed, using clicked item data as fallback");
        integrationState.setItemData(clickedItem);
        presentAdvertisementModal({
          onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
            if (ev.detail.role === "confirm") {
            }
          },
        });
      }
    } catch (error) {
      console.error("Error calling API:", error);
      integrationState.setItemData(clickedItem);
      presentAdvertisementModal({

        onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          if (ev.detail.role === "confirm") {
          }
        },
      });
    } finally {
      uiState.setIsLoading(false);
    }
  }

  const [presentAdvertisementModal, onDismissAdvertisement] = useIonModal(
    NhcAdvertisement,
    {
      objectId: logoState.objectId,
      adLicenseNumber: integrationState.adLicenseNumber,
      advertisement: integrationState.itItemData,
      onDismissAdvertisement: (data: string, role: string) =>
        onDismissAdvertisement(data, role),
    }
  );

  const callBackWatchPosition = mapFunctions.handleCallBackWatchPosition;

  let trackingMyLocationFunction = async (isNotClear: boolean) => {
    mapFunctions.handleTrackingLocation(
      isNotClear,
      mapLogic.graphicsLayer,
      mapLogic.MapViewData,
      (position: "top" | "middle" | "bottom", color: string, message: string) =>
        presentToastFunction(presentToast, position, color, message)
    );
  };

  const createFavoriteLand = async () => {
    try {
      uiState.setIsLoading(true);

      // First, create the favorite land feature on the map
      const result = await mapFunctions.handleCreateFavoriteLand(
        featureState.property,
        logoState.parcel_Cod,
        locationState.city_Name,
        locationState.region_Name,
        locationState.district_Name,
        formState.propertyNumber,
        null, // pPointgraphic not needed for utility function
        window.F_FavoriteLand
      );

      // If the map feature was created successfully, call the API
      if (result && result.addFeatureResults && result.addFeatureResults[0]) {
        const objectId = result.addFeatureResults[0].objectId;

        // Get the centroid coordinates from the property geometry
        const centroid = featureState.property?.geometry ?
          getPolygonCenterPoint(featureState.property.geometry as any) : null;

        // Call the API to create favorite land
        const apiResult = await createFavoriteLandFunction(
          logoState.parcel_Cod,
          userInfo.id,
          token,
          locationState.region_Name,
          locationState.city_Name,
          locationState.district_Name,
          featureState.property?.parcelNo || "",
          centroid?.longitude || 0,
          centroid?.latitude || 0,
          objectId
        );

        if (apiResult?.data.errorResult) {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `يرجي اضافه رقم جوالك بالنظام اولا , اذا كنت اضفته من قبل يرجي تسجيل الخروج ثم الدخول مره ثانيه`
          );
          deletePoint(objectId);
        } else if (apiResult?.data?.data == "deplicateEnters") {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `تم اضافة القطعة من قبل `
          );
          deletePoint(objectId);
        } else if (apiResult?.data?.data == "landHaveAdds") {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `عفوا لايمكن اضافه القطعه للمفضلة لان يوجد عليها عروض `
          );
          deletePoint(objectId);
        } else if (apiResult?.data?.data?.parcel_Cod) {
          presentToastFunction(
            presentToast,
            "top",
            "success",
            "تمت الإضافة بنجاح"
          );
        }
      }

      window.F_FavoriteLand.refresh();
    } catch (error) {
      console.error('Error creating favorite land:', error);
      presentToastFunction(
        presentToast,
        "top",
        "danger",
        `عفوا حدث خطأ ${error}`
      );
    } finally {
      uiState.setIsLoading(false);
    }
  };

  const getBuildingsWalletFuncData = () => {
    uiState.setIsLoading(true);
    GetBuildingsWalletFunc(userInfo.id, token)
      .then((returnedData) => {
        // Check if graphicsbuildingsWalletLayer exists before calling removeAll
        if (mapLogic.graphicsbuildingsWalletLayer) {
          mapLogic.graphicsbuildingsWalletLayer.removeAll();
        }
        let buildingsWalletDat = returnedData.data.data;
        // //console.log("buildingsWalletData", buildingsWalletDat);
        if (buildingsWalletDat.length > 0 && mapLogic.graphicsbuildingsWalletLayer) {
          buildingsWalletDat.forEach((element: any) => {
            generatetBuildingsWalletFuncLogos(
              element.id,
              element.longitude,
              element.latitude,
              element.parcel_Cod,
              element.land_Numbe,
              element.title
            );
          });
        }
        uiState.setIsLoading(false);
      })
      .catch((e) => {
        //console.log(e);
        uiState.setIsLoading(false);
      });
  }

  const handleLocationShare = async () => {
    uiState.setIsLoading(true);
    //TODO: turnned off for mobile
    setTimeout(async () => {
      let message = ` قطعة: ${formState.propertyNumber} | ${locationState.district_Name?.replace("حي ", "")} | ${locationState.city_Name}`;

      if (isPlatform("ios")) {
        uiState.setIsLoading(false);
        return;
      }

      if (isPlatform("mobileweb")) {
        shareOnWhatsAppFunction(locationState.currentLongitude || 0, locationState.currentLatitude || 0, message, true);
        //} else if (isPlatform("android") || isPlatform("ios")) {
      } else if (isPlatform("android")) {
        const url = `https://thki.sa/app/${locationState.currentLongitude}/${locationState.currentLatitude}`;
        const whatsappUrl = `whatsapp://send?text=${encodeURIComponent(message + "\n" + url)}`;
        window.open(whatsappUrl, "_system");
      } else {
        shareOnWhatsAppFunction(locationState.currentLongitude || 0, locationState.currentLatitude || 0, message, true);
      }
      uiState.setIsLoading(false);
    }, 2500);
  };

  function createBuildingsWallet() {
    uiState.setIsLoading(true);

    // Calculate centroid from polygon geometry
    const centroid = featureState.property?.geometry ? getPolygonCenterPoint(featureState.property.geometry as any) : null;

    let model = {
      Parcel_Cod: logoState.parcel_Cod,
      City_Name: locationState.city_Name,
      region_Name: locationState.region_Name,
      district_Name: locationState.district_Name,
      Land_Numbe: formState.propertyNumber,
      Longitude: centroid?.longitude || 0,
      Latitude: centroid?.latitude || 0,
    };
    CreateBuildingsWalletFunc(model, token)
      .then((result: any) => {
        if (result.data.result == "deplicateEnters") {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            `تم اضافة القطعة من قبل `
          );
        } else if (result.data.result == true) {
          presentToastFunction(
            presentToast,
            "top",
            "success",
            "تمت الإضافة بنجاح"
          );
          getBuildingsWalletFuncData();
        }
        uiState.setIsLoading(false);
      })
      .catch((err) => {
        uiState.setIsLoading(false);
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          `عفوا حدث خطأ ${err}`
        );
      });
  }

  function featureGeometry(type: any, features: any, wKid: any) {
    let obj: any = {
      type: type,
      spatialReference: {
        wkid: wKid,
      },
    };
    switch (type) {
      case "polyline":
        obj["paths"] = features;
        break;
      case "polygon":
        obj["rings"] = features;
    }
    return obj;
  }

  function editLandNumberId(obj: any, newLandNumberId: any) {
    let affFeatureLandUrl = arcgisServicesBaseUrl + "7/updateFeatures";
    let benchEdit = `[
          {
            "attributes": {
              "OBJECTID": ${obj},
              "Land_Numbe": '${newLandNumberId}'
            }
          }
        ]
        `;
    let formDataT = new FormData();
    formDataT.set("f", "json");
    formDataT.set("Features", benchEdit);
    let benchEditOption: any = {
      body: formDataT,
      responseType: "json",
    };

    Request(affFeatureLandUrl, benchEditOption)
      .then((response) => {
        presentToastFunction(presentToast, "top", "success", "تم تحديث بنجاح");
        window.F_Land_parcels.refresh();
      })
      .catch((err) => {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          `عفوا حدث خطأ ${err}`
        );
      });
  }

  const handleDataFromChild = (data: any) => {
    if (data == "startDriving") {
      if (!uiState.isTrackingMyLocationIsOpen) {
        uiState.setTrackingModalMode("driving");
        uiState.setTrackingMyLocationIsOpen(true);
        trackingMyLocationFunction(true);
      }
    }
  };

  // Measurement functions
  const handleAreaMeasurement = () => {
    if (mapLogic.MapViewData) {
      clearMeasurement(); // Clear any existing measurements
      setMeasuringMode('area');
      setIsMeasuring(true);
      measurementModeRef.current = true;
      setCurrentMeasurement(0);
      setMeasurementPoints([]);
      measurementPointsRef.current = []; // Clear the ref as well

      presentToastFunction(
        presentToast,
        "top",
        "info",
        "انقر على الخريطة لرسم المضلع."
      );

      // Temporarily disable the plot data click handler
      if (plotDataClickHandlerRef.current) {
        plotDataClickHandlerRef.current.remove();
      }

      // Create a new click handler for measurement
      const clickHandler = mapLogic.MapViewData.on('click', (event: any) => {
        handleAreaDrawing(event.mapPoint);
      });

      setMeasurementClickHandler(clickHandler);
    }
  };

  const handleDistanceMeasurement = () => {
    if (mapLogic.MapViewData) {
      clearMeasurement(); // Clear any existing measurements
      setMeasuringMode('distance');
      setIsMeasuring(true);
      measurementModeRef.current = true;
      setCurrentMeasurement(0);
      setMeasurementPoints([]);
      measurementPointsRef.current = []; // Clear the ref as well

      presentToastFunction(
        presentToast,
        "top",
        "info",
        "انقر على الخريطة لرسم الخط. انقر مرتين لإنهاء القياس."
      );

      // Temporarily disable the plot data click handler
      if (plotDataClickHandlerRef.current) {
        plotDataClickHandlerRef.current.remove();
      }

      // Create a new click handler for measurement
      const clickHandler = mapLogic.MapViewData.on('click', (event: any) => {
        handleDistanceDrawing(event.mapPoint);
      });

      setMeasurementClickHandler(clickHandler);
    }
  };

  const handleAreaDrawing = (point: Point) => {
    const markerSymbol = {
      type: "simple-marker",
      style: "circle",
      size: "8px",
      color: "#22c55e",
      outline: {
        color: "#ffffff",
        width: "2px"
      }
    };

    const pointGraphic = new Graphic({
      geometry: point,
      symbol: markerSymbol
    });

    if (mapLogic.graphicsLayer) {
      mapLogic.graphicsLayer.add(pointGraphic);
      console.log("Added area point graphic. Total graphics:", mapLogic.graphicsLayer.graphics.length);
    } else {
      console.error("Graphics layer not available for area measurement");
    }

    // Update both ref and state
    const newPoints = [...measurementPointsRef.current, point];
    measurementPointsRef.current = newPoints;
    setMeasurementPoints(newPoints);

    console.log("Area points count:", newPoints.length, "Points:", newPoints);

    if (newPoints.length > 2) {
      calculateArea(newPoints);
    }
  };

  const handleDistanceDrawing = (point: Point) => {
    const markerSymbol = {
      type: "simple-marker",
      style: "circle",
      size: "8px",
      color: "#3b82f6",
      outline: {
        color: "#ffffff",
        width: "2px"
      }
    };

    const pointGraphic = new Graphic({
      geometry: point,
      symbol: markerSymbol
    });

    if (mapLogic.graphicsLayer) {
      mapLogic.graphicsLayer.add(pointGraphic);
      console.log("Added distance point graphic. Total graphics:", mapLogic.graphicsLayer.graphics.length);
    } else {
      console.error("Graphics layer not available for distance measurement");
    }

    // Update both ref and state
    const newPoints = [...measurementPointsRef.current, point];
    measurementPointsRef.current = newPoints;
    setMeasurementPoints(newPoints);

    console.log("Distance points count:", newPoints.length, "Points:", newPoints);

    if (newPoints.length > 1) {
      calculateDistance(newPoints);
    }
  };

  const calculateDistance = (points: Point[]) => {
    if (points.length < 2) return;

    // Remove any existing polylines first
    if (mapLogic.graphicsLayer) {
      const existingLines: any[] = [];
      mapLogic.graphicsLayer.graphics.forEach((graphic: any) => {
        if (graphic.geometry && graphic.geometry.type === "polyline") {
          existingLines.push(graphic);
        }
      });
      existingLines.forEach((g: any) => mapLogic.graphicsLayer.remove(g));
    }

    const polyline = new Polyline({
      paths: [points.map(point => [point.x, point.y])],
      spatialReference: mapLogic.MapViewData.spatialReference
    });

    const lineSymbol = new SimpleLineSymbol({
      color: "#3b82f6",
      width: 3
    });

    const lineGraphic = new Graphic({
      geometry: polyline,
      symbol: lineSymbol
    });

    if (mapLogic.graphicsLayer) {
      mapLogic.graphicsLayer.add(lineGraphic);
      console.log("Added distance line graphic. Total graphics:", mapLogic.graphicsLayer.graphics.length);
    } else {
      console.error("Graphics layer not available for distance line");
    }

    try {
      const distance = geometryEngine.geodesicLength(polyline, 'meters');
      setCurrentMeasurement(distance);
    } catch (error) {
      console.error("Error calculating distance:", error);
    }
  };

  const calculateArea = (points: Point[]) => {
    if (points.length < 3) return;

    // Remove any existing polygons first
    if (mapLogic.graphicsLayer) {
      const existingPolygons: any[] = [];
      mapLogic.graphicsLayer.graphics.forEach((graphic: any) => {
        if (graphic.geometry && graphic.geometry.type === "polygon") {
          existingPolygons.push(graphic);
        }
      });
      existingPolygons.forEach((g: any) => mapLogic.graphicsLayer.remove(g));
    }

    // Create polygon ring and close it
    const ring = points.map(point => [point.x, point.y]);
    ring.push([points[0].x, points[0].y]); // Close the polygon

    const polygon = new Polygon({
      rings: [ring],
      spatialReference: mapLogic.MapViewData.spatialReference
    });

    const fillSymbol = new SimpleFillSymbol({
      color: [34, 197, 94, 0.3],
      outline: new SimpleLineSymbol({
        color: "#22c55e",
        width: 3
      })
    });

    const polygonGraphic = new Graphic({
      geometry: polygon,
      symbol: fillSymbol
    });

    if (mapLogic.graphicsLayer) {
      mapLogic.graphicsLayer.add(polygonGraphic);
      console.log("Added area polygon graphic. Total graphics:", mapLogic.graphicsLayer.graphics.length);
    } else {
      console.error("Graphics layer not available for area polygon");
    }

    try {
      const area = geometryEngine.geodesicArea(polygon, 'square-meters');
      setCurrentMeasurement(Math.abs(area));
    } catch (error) {
      console.error("Error calculating area:", error);
    }
  };

  const clearMeasurement = () => {
    setMeasuringMode(null);
    setIsMeasuring(false);
    measurementModeRef.current = false;
    setCurrentMeasurement(0);
    setMeasurementPoints([]);
    measurementPointsRef.current = []; // Clear the ref as well

    if (mapLogic.graphicsLayer) {
      mapLogic.graphicsLayer.removeAll();
    }

    // Remove measurement click handler
    if (measurementClickHandler) {
      measurementClickHandler.remove();
      setMeasurementClickHandler(null);
    }

    // Re-enable plot data click handler
    if (mapLogic.MapViewData) {
      getPlotData();
    }
  };

  const [docsReportModelPresent, docsReportModelDismiss] = useIonModal(
    DocsReportModel,
    {
      docsReportModelDismiss: (data: string, role: string) =>
        docsReportModelDismiss(data, role),
    }
  );

  function docsReportModelFunc() {
    docsReportModelPresent({
      animated: true,
      breakpoints: [0.6, 1, 1, 0.5, 1],
      initialBreakpoint: 0.8,
      // backdropBreakpoint: 0.8,
      onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
        if (ev.detail.role === "confirm") {
        }
      },
    });
  }

  // Adds the solved route to the map as a graphic
  function showRoute(data: any) {
    // //console.log("showRoute==>data", data);

    // Use the routing function to add route to map
    const routeData = mapFunctions.handleShowRoute(data);

    if (routeData && routeData.routeResult) {
      // Handle UI state changes
      uiState.setPropertyModalIsOpen(false);
      uiState.setTrackingModalMode("tracking");
      uiState.setTrackingModalData({
        routeResult: routeData.routeResult,
        landAddress: formState.landAddress,
      } as any);
    }

    uiState.setIsLoading(false);
  }

  return (
    <IonPage>
      <IonContent>
        <div className="h-screen" style={{ position: "relative" }}>
          <div className="w-full max-h-screen h-full" id="viewDivMap" />

          {uiState.trackingModalMode &&
            uiState.trackingModalMode != "" &&
            uiState.trackingModalData && (
              <TrackingModals
                mode={uiState.trackingModalMode}
                data={uiState.trackingModalData} // Pass data as props
                onDataChange={handleDataFromChild} // Callback to receive data from child
                onClose={() => {
                  uiState.setTrackingModalMode(null);
                  uiState.setTrackingMyLocationIsOpen(false);
                  trackingMyLocationFunction(false);
                  mapFunctions.handleClearRoute(routeParams, mapLogic.routeLayer);
                }} // Example callback to close modal
              />
            )}
          {/* <TrackingModals /> */}
          {uiState.isLoading ? <Spinner color={"primary"} size={"large"} /> : null}

          {/* Measurement Mode Indicator */}
          {isMeasuring && (
            <div className="absolute top-20 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-90 text-white px-6 py-3 rounded-lg z-50 animate__animated animate__fadeInDown shadow-lg">
              <div className="text-center">
                <p className="text-sm font-bold mb-2">
                  {measuringMode === 'area' ? 'وضع قياس المساحة' : 'وضع قياس المسافة'}
                </p>
                <p className="text-xs mb-2">
                  النقاط المحددة: {measurementPoints.length}
                </p>
                {currentMeasurement > 0 && (
                  <p className="text-xs mb-2 text-green-300">
                    {measuringMode === 'area'
                      ? `المساحة الحالية: ${currentMeasurement.toFixed(2)} متر مربع`
                      : `المسافة الحالية: ${currentMeasurement.toFixed(2)} متر`
                    }
                  </p>
                )}
                <p className="text-xs mb-3">
                  {measuringMode === 'area'
                    ? "انقر لإضافة نقاط (3+ نقاط للمساحة)"
                    : "انقر لإضافة نقاط (2+ نقاط للمسافة)"
                  }
                </p>
                <button
                  onClick={clearMeasurement}
                  className="px-4 py-2 bg-red-500 text-white text-xs rounded hover:bg-red-600 transition-colors"
                >
                  إلغاء القياس
                </button>
              </div>
            </div>
          )}

          {!uiState.trackingModalMode && (
            <div
              className={`bottom-0 fixed left-0 md:flex ${!uiState.isLoading && "animate__animated animate__backInUp"
                }`}
              style={{
                width: "100px",
                bottom: "14px",
                opacity: "0.6!important",
              }}
              onClick={() => {
                window.open(
                  "https://eservicesredp.rega.gov.sa/public/OfficesBroker/LicenseDetails/Bmlp/08dc09e4-10fd-4217-8944-923d55eda7ff",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              <div
                className="bottom-0 fixed left-0 md:flex"
                style={{
                  left: "8px",
                  margin: "0 auto",
                  maxWidth: "30px",
                  bottom: "2px",
                }}
              >
                <QRCode
                  size={256}
                  className="pb-2"
                  style={{ height: "auto", maxWidth: "150%" }}
                  value={`https://eservicesredp.rega.gov.sa/public/OfficesBroker/LicenseDetails/Bmlp/08dc09e4-10fd-4217-8944-923d55eda7ff`}
                  viewBox={`0 0 256 256`}
                />
              </div>
              <img src={FalLogo} />
            </div>
          )}

          {!uiState.trackingModalMode && (
            <div className="absolute top-0 pt-4 w-full">
              <div className="w-full flex flex-row justify-start item-center px-12">
                <div className="grid grid-cols-3 gap-4 w-full">
                  <div className="flex flex-row justify-start items-center"></div>

                  <div className="flex flex-col justify-center items-center mt-8 gap-4">
                    {/* Logo on Top */}
                    <div className="flex-shrink-0">
                      <img src={Logo} height={"70"} width={"70"} />
                    </div>

                    {/* Single filters dropdown below the logo */}
                    <div className="relative flex flex-row justify-center items-center">
                      <button
                        onClick={() => uiState.setFiltersDropdownOpen(!uiState.filtersDropdownOpen)}
                        className={`px-4 py-2 bg-transparent rounded-xl transition-all duration-200 flex items-center justify-center gap-2 border-2 border-solid flex-shrink-0 ${activeFilterCount > 0
                            ? 'border-blue-500 text-blue-500 shadow-md'
                            : 'border-blue-500 text-gray-400 opacity-60'
                          }`}
                        title="الفلاتر"
                      >
                        <span className="text-lg font-medium">الفلاتر</span>
                        {activeFilterCount > 0 && (
                          <span className="text-sm font-bold">({activeFilterCount})</span>
                        )}
                      </button>

                      <FiltersDropdown
                        isOpen={uiState.filtersDropdownOpen}
                        onClose={() => uiState.setFiltersDropdownOpen(false)}
                        propertyTypes={propertyTypes}
                        selection={offerSelection}
                        onToggleType={handleToggleType}
                        onPickDeal={handlePickDeal}
                        isLoading={isLoadingMapAds}
                        showRequests={uiState.showFavoriteIcons}
                        onToggleRequests={() => {
                          const newState = !uiState.showFavoriteIcons;
                          uiState.setShowFavoriteIcons(newState);
                          mapLogic.toggleFavoriteIcons(newState);
                        }}
                        showWallets={uiState.showWalletIcons}
                        onToggleWallets={() => {
                          const newState = !uiState.showWalletIcons;
                          uiState.setShowWalletIcons(newState);
                          mapLogic.toggleWalletIcons(newState);
                        }}
                      />
                    </div>
                  </div>
                  <div className={`flex flex-row justify-self-end h-fit w-fit mt-8`}>
                    {/* {authenticationState == "authenticated" ? ( */}
                    <div className="h-12 w-12">
                      <button id="popover-button">
                        <IonPopover
                          trigger="popover-button"
                          dismissOnSelect={true}
                          mode="ios"
                        >
                          <IonContent className="animate__animated animate__jackInTheBox">
                            <IonList className="p-2">
                              {authenticationState == "authenticated" ? (
                                <IonItem
                                  button={true}
                                  detail={true}
                                  detailIcon={caretDownCircleOutline}
                                  onClick={() => openProfileModal()}
                                >
                                  القائمة الرئيسية
                                </IonItem>
                              ) : (
                                <IonItem
                                  button={true}
                                  detail={true}
                                  detailIcon={LoginImage}
                                  onClick={() => {
                                    setSignInAsVisitorFunction(false);
                                    window.location.assign(`/app/signIn`);
                                  }}
                                >
                                  تسجيل الدخول
                                </IonItem>
                              )}
                              {window.F_Land_parcels ? (
                                <IonItem
                                  button={true}
                                  detail={true}
                                  detailIcon={searchOutline}
                                  onClick={() => {
                                    uiState.setFilterModalIsOpen(true);
                                  }}
                                >
                                  البحث
                                </IonItem>
                              ) : null}
                              <IonItem
                                button={true}
                                detail={true}
                                detailIcon={receiptOutline}
                                onClick={() => uiState.setLegendModalIsOpen(true)}
                              >
                                دليل الوان ذكي
                              </IonItem>
                              <IonItem
                                button={true}
                                detail={true}
                                detailIcon={newspaperOutline}
                                onClick={() => docsReportModelFunc()}
                              >
                                دليل المستخدم
                              </IonItem>
                              {authenticationState == "authenticated" ? (
                                <IonItem
                                  button={true}
                                  detail={true}
                                  detailIcon={add}
                                  onClick={() => openpAddPropertyModal()}
                                >
                                  اضافة عقار
                                </IonItem>
                              ) : null}
                            </IonList>
                          </IonContent>
                        </IonPopover>
                        <IonIcon
                          icon={menuImage}
                          className="text-5xl text-primaryColor100 cursor-pointer"
                        />{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!uiState.trackingModalMode && (
            <div
              className={`absolute left-0 pt-20 top-0 ${!uiState.isLoading && "animate__animated animate__backInUp"
                }`}
            >
              <div
                className="fixed w-12 left-0 ml-5 mt-16 pt-3"
                style={{
                  width: uiState.isTrackingMyLocationIsOpen ? "78px" : undefined,
                }}
              >
                {uiState.isTrackingMyLocationIsOpen && (
                  <IonIcon
                    className="text-3xl cursor-pointer"
                    icon={close}
                    onClick={() => {
                      uiState.setTrackingMyLocationIsOpen(false);
                      trackingMyLocationFunction(false);
                    }}
                  />
                )}
                <button
                  className={`shadow-md drop-shadow-md h-12 w-12 rounded-full absolute ${uiState.isTrackingMyLocationIsOpen
                    ? "cursor-default"
                    : "cursor-pointer"
                    } bg-white bg-opacity-60`}
                  onClick={() => {
                    // //console.log(
                    //   "click agian isZoomTracking is",
                    //   isZoomTracking
                    // );
                    // //console.log(
                    //   "click agian isTrackingMyLocationIsOpen",
                    //   uiState.isTrackingMyLocationIsOpen
                    // );
                    if (!uiState.isTrackingMyLocationIsOpen) {
                      uiState.setTrackingMyLocationIsOpen(true);
                      trackingMyLocationFunction(true);
                    } else {
                      isZoomTracking = false;
                      uiState.setTrackingMyLocationIsOpen(true);
                      trackingMyLocationFunction(true);
                    }
                  }}
                >
                  <IonIcon
                    icon={navigate}
                    className="text-2xl text-primaryColor100 mt-1"
                  />
                </button>
              </div>
              <div className="pt-20 w-16">
                <button
                  className={`shadow-md drop-shadow-md h-16 w-16 rounded-full fixed left-0 ml-5 mt-16 animate__animated animate__heartBeat animate__infinite bg-primaryColor100 bg-opacity-100`}
                  onClick={() => {
                    openEstateBrokersModal();
                  }}
                >
                  <IonIcon
                    icon={realEstateBrokerSvg}
                    className="text-4xl text-white mt-1"
                  />
                </button>

                {/* Dropdown Icon */}
                <div className="relative">
                  <button
                    className="shadow-md drop-shadow-md h-14 w-14 rounded-full fixed left-0 ml-5 mt-36 bg-white bg-opacity-80 hover:bg-opacity-100 transition-all duration-200 cursor-pointer"
                    onClick={() => uiState.setMeasuringToolsDropdownOpen(!uiState.measuringToolsDropdownOpen)}
                  >
                    <IonIcon
                      icon={ruler}
                      className="text-4xl text-primaryColor100"
                    />
                  </button>

                  {/* Measuring Tools Dropdown */}
                  {uiState.measuringToolsDropdownOpen && (
                    <div className="absolute left-0 ml-6 mt-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-32 z-50 animate__animated animate__fadeInDown">
                      <button
                        className="w-full px-4 py-2 text-right text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-150 flex items-center justify-between"
                        onClick={() => {
                          uiState.setMeasuringToolsDropdownOpen(false);
                          handleAreaMeasurement();
                        }}
                      >
                        <span>قياس المساحة</span>
                        <IonIcon icon={receiptOutline} className="text-lg text-primaryColor100" />
                      </button>

                      <button
                        className="w-full px-4 py-2 text-right text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-150 flex items-center justify-between"
                        onClick={() => {
                          uiState.setMeasuringToolsDropdownOpen(false);
                          handleDistanceMeasurement();
                        }}
                      >
                        <span>قياس المسافة</span>
                        <IonIcon icon={navigate} className="text-lg text-primaryColor100" />
                      </button>

                      {isMeasuring && (
                        <button
                          className="w-full px-4 py-2 text-right text-sm text-white bg-red-500 hover:bg-red-600 transition-colors duration-150 flex items-center justify-center"
                          onClick={() => {
                            uiState.setMeasuringToolsDropdownOpen(false);
                            clearMeasurement();
                          }}
                        >
                          <span>إلغاء القياس</span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <WhatsAppModal
          isOpen={uiState.whatsUpIsOpen}
          onClose={() => uiState.setWhatsUpIsOpen(false)}
          propertyNumber={formState.propertyNumber}
          district_Name={locationState.district_Name}
          city_Name={locationState.city_Name}
          parcel_Cod={logoState.parcel_Cod}
          propertyAdvertisements={propertyDataState.propertyAdvertisements}
          currentLongitude={locationState.currentLongitude}
          currentLatitude={locationState.currentLatitude}
          shareOnWhatsAppFunction={shareOnWhatsAppFunction}
          isLoading={uiState.isLoading}
          setIsLoading={uiState.setIsLoading}
        />

        <CreateFavoriteLandModal
          isOpen={featureState.isCreateFavoriteLand}
          onClose={() => featureState.setIsCreateFavoriteLand(false)}
          onCreateFavoriteLand={createFavoriteLand}
        />

        <CreateBuildingsWalletModal
          isOpen={featureState.isCreateBuildingsWallet}
          onClose={() => featureState.setIsCreateBuildingsWallet(false)}
          onCreateBuildingsWallet={createBuildingsWallet}
        />

        <SignInModal
          isOpen={uiState.isOpenSignIn}
          onClose={() => uiState.setIsOpenSignIn(false)}
        />

        <EditModal
          isOpen={uiState.editIsOpen}
          onClose={() => uiState.setEditIsOpen(false)}
          onEdit={(newLandNumber: any) => editLandNumberId(logoState.objectId, newLandNumber)}
          currentLandNumber={formState.parcelNumberOrText}
        />

        <LandOperationsModal
          isOpen={uiState.landOperationsIsOpen}
          onClose={() => uiState.setLandOperationsIsOpen(false)}
          onOperationSelect={(operation: string) => {
            if (operation === "1") {
              uiState.setEditIsOpen(true);
              uiState.setLandOperationsIsOpen(false);
            } else if (operation === "2") {
              uiState.setLogoPointsIsOpen(true);
              uiState.setLandOperationsIsOpen(false);
            } else if (operation === "3") {
              changeFlashLightFeature();
              uiState.setLandOperationsIsOpen(false);
            }
          }}
          isAdmin={userRoleState.isAdmin}
          isOperation={userRoleState.isOperation}
        />

        <LogoPointsModal
          isOpen={uiState.logoPointsIsOpen}
          onClose={() => uiState.setLogoPointsIsOpen(false)}
          getLogosData={featureState.getLogosData}
          parcel_Cod={logoState.mapObjectId}
          logoId={logoState.logoId}
          token={token}
          isOperation={userRoleState.isOperation}
          logoPointsTypeValue={logoState.logoPointsTypeValue}
          setLogoPointsTypeValue={logoState.setLogoPointsTypeValue}
          property={featureState.property}
          onDeleteLogo={async (logoId: string) => {
            const result = await deleteLogosDataFunction(logoId, token);
            if (result) {
              mapFunctions.handleRemoveLogoGraphics(logoId, mapLogic.graphicsLogoLayer, mapLogic.graphicsLogoLayerlogoAdd);
              handleRemoveLogos(logoId);
              presentToastFunction(
                presentToast,
                "top",
                "success",
                "تم الحذف بنجاح"
              );
              uiState.setLogoPointsIsOpen(false);
            }
          }}
          onAddLogo={async (model: any) => {
            uiState.setIsLoading(true);
            try {
              const result = await createLogosDataFunction(model, token);
              if (result) {
                getLogoData();
                presentToastFunction(
                  presentToast,
                  "top",
                  "success",
                  "تمت الإضافه بنجاح"
                );
                uiState.setLogoPointsIsOpen(false);
                uiState.setIsLoading(false);
              }
              logoState.setLogoPointsActiveValue("");
              logoState.setLogoPointsTypeValue("");
              logoState.setLogoFile("");
              logoState.setLogoPointsZoomLevelValue("");
              uiState.setIsLoading(false);
            } catch (error) {
              uiState.setIsLoading(false);
              presentToastFunction(
                presentToast,
                "top",
                "danger",
                `${error} عفوا خطئ اثناء الحفظ`
              );
            }
          }}
          inputClassWithOutError={inputClassWithOutError}
          inputClassWithError={inputClassWithError}
        />

        <FilterModal
          isOpen={uiState.filterModalIsOpen}
          onClose={() => uiState.setFilterModalIsOpen(false)}
          isLoading={uiState.isLoading}
          region={formState.selectedRegion}
          city={formState.selectedCity}
          district={formState.selectedDistrict}
          plan={formState.selectedPlan}
          parcel={formState.selectedParcel}
          hasCities={dataArraysState.cities.length > 0}
          hasDistricts={dataArraysState.districts.length > 0}
          hasPlans={dataArraysState.plans.length > 0}
          hasParcels={dataArraysState.parcels.length > 0}
          onRegionClick={() => {
            searchState.setIsModalOpen("region");
            searchState.setFilteredData(dataArraysState.regions);
          }}
          onCityClick={() => {
            searchState.setIsModalOpen("city");
            searchState.setFilteredData(dataArraysState.cities);
          }}
          onDistrictClick={() => {
            searchState.setIsModalOpen("district");
            searchState.setFilteredData(dataArraysState.districts);
          }}
          onPlanClick={() => {
            searchState.setIsModalOpen("plan");
            searchState.setFilteredData(dataArraysState.plans);
          }}
          onParcelClick={() => {
            searchState.setIsModalOpen("parcel");
            searchState.setFilteredData(dataArraysState.parcels);
          }}
          onOpenInfoModal={(data) => {
            formState.setPropertyNumber(data.parcelNo)
            locationState.setregion_Name(data.region);
            locationState.setcity_Name(data.city);
            locationState.setdistrict_Name(data.districtName);
            featureState.setProperty((prev: any) => ({
              ...prev,
              landuse: data.landuse || "",
              planNO: data.planNO || "",
              streetinfo: data.streetinfo || [],
              area: data.area || "",
              directionParcel: data.directionParcel || [],
            }));
            uiState.setInfoModalIsOpen(true);
          }}
          onGoToCoordinates={(rings) => {
            // Navigate to the coordinates on the map
            zoomToLayer("polygon", rings, 4326, false);
          }}
        />

        <PropertyModal
          isOpen={uiState.propertyModalIsOpen}
          onClose={() => {
            // Use setTimeout to avoid React DOM issues during modal dismissal
            setTimeout(() => {
              uiState.setPropertyModalIsOpen(false);
            }, 0);
          }}
          landAddress={formState.landAddress}
          isAdmin={userRoleState.isAdmin}
          isOperation={userRoleState.isOperation}
          isUser={userRoleState.isUser}
          authenticationState={authenticationState}
          propertyAdvertisements={propertyDataState.propertyAdvertisements}
          property={featureState.property}
          buildingWalletSingle={buildingWalletSingle}
          onInfoClick={() => uiState.setInfoModalIsOpen(true)}
          onLandOperationsClick={() => uiState.setLandOperationsIsOpen(true)}
          onWhatsAppClick={handleLocationShare}
          onGoogleMapsClick={() => { }}
          onFavoriteClick={() => { }}
          onNavigationClick={() => { }}
          onWalletClick={() => { }}
          onAdvertisementClick={openAdvertisementModal}
          onSignInClick={() => uiState.setIsOpenSignIn(true)}
          onCreateFavoriteLandClick={() => featureState.setIsCreateFavoriteLand(true)}
          onCreateBuildingsWalletClick={() => featureState.setIsCreateBuildingsWallet(true)}
          NumberWithCommas={NumberWithCommas}
          getPolygonCenterPoint={getPolygonCenterPoint}
          showOnGoogleMapsFunction={showOnGoogleMapsFunction}
          handleStyleButtonByLandTypes={handleStyleButtonByLandTypes}
          routeLayer={mapLogic.routeLayer}
          addStop={addStop}
          currentEventClick={propertyDataState.currentEventClick}
          setIsLoading={uiState.setIsLoading}
          routeParams={routeParams}
        />

        <FavoriteLandByParcCodeModal
          isOpen={uiState.favoriteLandByParcCodeModalIsOpen}
          onClose={() => uiState.setFavoriteLandByParcCodeModalIsOpen(false)}
          isLoading={uiState.isLoading}
          propertyFavoriteLand={propertyDataState.propertyFavoriteLand}
        />

        <LegendModal
          isOpen={uiState.legendModalIsOpen}
          onClose={() => uiState.setLegendModalIsOpen(false)}
          legendImage={LegendImage}
        />

        <SearchSelectionModal
          isOpen={searchState.isModalOpen != ""}
          onClose={() => {
            searchState.setIsModalOpen("");
            searchState.setSearchQuery("");
          }}
          searchQuery={searchState.searchQuery}
          filteredData={searchState.filteredData}
          onSearch={(e: CustomEvent) => handleSearch(e)}
          onSelectItem={handleSelectItem}
        />

        {/* {uiState.infoModalIsOpen && (
        <TrackingModals 
        isOpen={uiState.trackingModalMode}
          setIsopen={uiState.setTrackingModalMode}
          data={uiState.trackingModalData}
        />
        )} */}

        <InfoModal
          isOpen={uiState.infoModalIsOpen}
          onClose={() => uiState.setInfoModalIsOpen(false)}
          propertyNumber={formState.propertyNumber}
          region_Name={locationState.region_Name}
          city_Name={locationState.city_Name}
          district_Name={locationState.district_Name}
          Parcel_Status={featureState?.property?.landuse}
          plan_Id={featureState?.property?.planNO}
          propertyAdvertisements={propertyDataState.propertyAdvertisements}
          streetInfo={featureState.property?.streetinfo}
          area={featureState.property?.area}
          directionParcel={featureState.property?.directionParcel}
        />

      </IonContent>
    </IonPage>
  );
};

export default Home;
